function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import md5 from 'md5';
import { CoreVideoInternal } from '../../core-video-internal';
import { CvsdkError, ErrorSeverity } from '../../error';
import { TimedActionsScheduler } from '../../players/bolt-ons/timed-actions-scheduler';
import { InterpolatedPosition, InterpolationStrategies } from '../../utils/interpolated-position';
import { JsonUtils } from '../../utils/json-utils';
import { createErrorLoggingObservable } from '../../utils/observables/error-logging-observable';
import { createErrorLogger } from '../../utils/observables/observable';
import { PerfKey, perfLogger, PerfTag } from '../../utils/perf';
import { checkIsManifestLinearType } from '../../utils/playback-type';
import { PlayerState } from './player-state';
import { cloneAdBreak, findCloseToAdBreakStartPosition } from '../../utils/ad-break-utils';
import { BufferAnalyser } from './buffer-analyser';
import { AdInsertionStrategy } from './playout-data';
import { SeekDataManager } from './seek-data-manager';
import { CompositeObservable } from '../../utils/observables/composite-observable';
import { SafeInterval } from '../../utils/safe-interval';
import { PlayerCommand, StopReason, TimedMetadataType } from './player.enums';
import { AudioRole } from './role';
export { TextTrackKind, TimedMetadataType } from './player.enums';
/**
 * @public
 */ /**
 * @public
 */ /*
    Examples for this can be:

    HLS Manifest
    #EXT-X-MEDIA:TYPE=AUDIO,URI="playlist_a-fra-0128k-aac-2c.mp4.m3u8",GROUP-ID="default-audio-group",LANGUAGE="fr",NAME="stream_7",AUTOSELECT=YES,CHANNELS="2"

    Core Video SDK Track
    {
        "id": "audio/mp4-1",
        "language": "fr",
        "name": "stream_7"
    },

    MSS Manifest
    <StreamIndex Chunks="326" Type="audio" Url="QualityLevels({bitrate})/Fragments(English={start time})" QualityLevels="1" Language="eng" Name="Surround English">

    {
        "id": "audio/mp4-2",
        "language": "eng",
        "name": "Surround English"
    }

*/ /**
 * @public
 */ /**
 * @public
 */ /**
 * @public
 */ // The combined audio/video buffered ranges, reported by `video.buffered`
// The buffered ranges for audio content
// The buffered ranges for video content
// TODO Specific to Sky Europe, remove streamMetadata, surface raw data through timedMetadata and do parsing at higher level
/**
 * @internal Interfaces for the native player implementations
 *         responsible for all the actions and event that
 *         targets playback
 */ export var BasePlayerEngineItem = /*#__PURE__*/ function() {
    "use strict";
    function BasePlayerEngineItem(playoutData, advertBoltOns, playerExtensions, playerEngineOptions, logger, configuration, debugConfig, precursor) {
        var _this = this;
        var _this1 = this;
        _class_call_check(this, BasePlayerEngineItem);
        var _this_debugConfig;
        _define_property(this, "playoutData", void 0);
        _define_property(this, "advertBoltOns", void 0);
        _define_property(this, "playerEngineOptions", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "configuration", void 0);
        _define_property(this, "debugConfig", void 0);
        _define_property(this, "precursor", void 0);
        _define_property(this, "state", void 0);
        _define_property(this, "bitRateLevel", void 0);
        _define_property(this, "id", void 0);
        _define_property(this, "duration", void 0);
        _define_property(this, "availableAudioTracks", void 0);
        _define_property(this, "availableTextTracks", void 0);
        _define_property(this, "currentBitrate", void 0);
        _define_property(this, "currentEncodedFrameRate", void 0);
        _define_property(this, "currentRenderedFrameRate", void 0);
        // Used for the public onStateChangedMethod, will not fire if ignoreStateChanges is true
        _define_property(this, "gatedPlayerStateObservable", void 0);
        // Will always notify observers if the state changes and is unaffected by the flag
        _define_property(this, "internalPlayerStateObservable", void 0);
        // DISCUSS: CDN OBSERVABLE: should be moved somewhere, because we ultimately want
        //                          only to playout so we just want a manifest uri/licensing uri
        //                          so CDN should be elected by the time this is constructed
        _define_property(this, "userStoppedObservable", void 0);
        _define_property(this, "bitrateObservable", void 0);
        _define_property(this, "encodedFrameRateObservable", void 0);
        _define_property(this, "renderedFrameRateObservable", void 0);
        _define_property(this, "videoTrackChangedObservable", void 0);
        _define_property(this, "currentPositionObservable", void 0);
        _define_property(this, "durationObservable", void 0);
        // DISCUSS: Buffer Info Observable: for what we can tell (after talking with David)
        //           this is/was used for linear rewind, in order to know the buffer available
        //           that we can actually use (I guess before falling into a VOD or something)
        //           not sure if this is actually used, it has a reference on the roku player
        //           should we include this?
        _define_property(this, "availableAudioTracksObservable", void 0);
        _define_property(this, "availableSubtitlesTracksObservable", void 0);
        _define_property(this, "availableThumbnailVariantsObservable", void 0);
        _define_property(this, "errorObservable", void 0);
        _define_property(this, "warningObservable", void 0);
        _define_property(this, "playStartObservable", void 0);
        _define_property(this, "seekEndedObservable", void 0);
        _define_property(this, "preSeekStartedObservable", void 0);
        _define_property(this, "streamMetadataObservable", void 0);
        _define_property(this, "timedMetadataObservable", void 0);
        _define_property(this, "bulkTimedMetadataObservable", void 0);
        _define_property(this, "currentAudioTrackObservable", void 0);
        _define_property(this, "currentSubtitlesTrackObservable", void 0);
        _define_property(this, "subtitleCuesObservable", void 0);
        _define_property(this, "volumeObservable", void 0);
        _define_property(this, "muteObservable", void 0);
        _define_property(this, "cdnSwitchObservable", void 0);
        _define_property(this, "manifestReceivedObservable", void 0);
        _define_property(this, "videoElementCreatedObservable", void 0);
        _define_property(this, "fullscreenChangedObservable", void 0);
        _define_property(this, "clickedObservable", void 0);
        _define_property(this, "autoPlayPolicyPreventedPlaybackObservable", void 0);
        _define_property(this, "errorContext", void 0);
        _define_property(this, "currentPosition", void 0);
        _define_property(this, "firstPositionUpdateSent", void 0);
        _define_property(this, "adEventsManager", void 0);
        _define_property(this, "adBreaksProvider", void 0);
        _define_property(this, "adBreakTimeAdapter", void 0);
        _define_property(this, "adPolicyManager", void 0);
        _define_property(this, "interpolatedPosition", void 0);
        _define_property(this, "liveWindow", void 0);
        _define_property(this, "seekDataManager", void 0);
        _define_property(this, "thumbnailManager", void 0);
        _define_property(this, "shouldIgnoreStateAndPositionChanges", void 0);
        _define_property(this, "stallDetector", void 0);
        _define_property(this, "subtitlesManager", void 0);
        _define_property(this, "dashManifestDownloader", void 0);
        _define_property(this, "isCurrentlyMuted", void 0);
        _define_property(this, "timedActionsScheduler", void 0);
        _define_property(this, "isLoading", void 0);
        _define_property(this, "isLoaded", void 0);
        _define_property(this, "modifiedBeforeLoad", void 0);
        _define_property(this, "renderedFrameRateInterval", void 0);
        _define_property(this, "bandwidthEstimator", void 0);
        _define_property(this, "adStartedObservable", void 0);
        _define_property(this, "adFinishedObservable", void 0);
        _define_property(this, "adBreakStartedObservable", void 0);
        _define_property(this, "adBreakFinishedObservable", void 0);
        _define_property(this, "adBreakDataReceivedObservable", void 0);
        _define_property(this, "adErrorObservable", void 0);
        _define_property(this, "adPositionObservable", void 0);
        _define_property(this, "seekStartedObservable", void 0);
        _define_property(this, "liveWindowChangedObservable", void 0);
        _define_property(this, "manifestParsedObservable", void 0);
        _define_property(this, "manifestUpdatedObservable", void 0);
        _define_property(this, "httpRequestObservable", void 0);
        _define_property(this, "httpResponseObservable", void 0);
        _define_property(this, "hasBeenStopped", void 0);
        _define_property(this, "bufferAnalyser", void 0);
        _define_property(this, "queuedEmsgEventIds", void 0);
        _define_property(this, "bulkTimedMetadataGatherer", void 0);
        _define_property(this, "liveWindowAnchor", void 0);
        // "Official" is set when we receive a seeking state from the PEI
        _define_property(this, "isOfficiallySeeking", void 0);
        _define_property(this, "notifyManifestParsed", void 0);
        _define_property(this, "notifyManifestUpdated", void 0);
        _define_property(this, "notifyPreSeekStarted", void 0);
        _define_property(this, "scheduleEmsgEvent", void 0);
        _define_property(this, "processEmsg", void 0);
        _define_property(this, "notifyAdBreakStarted", void 0);
        _define_property(this, "notifyAdBreakFinished", void 0);
        _define_property(this, "notifyAdBreakDataChanged", void 0);
        _define_property(this, "notifyAdStarted", void 0);
        _define_property(this, "notifyAdFinished", void 0);
        _define_property(this, "recoverStallBySeeking", void 0);
        _define_property(this, "addPrimaryLanguageFlag", void 0);
        _define_property(this, "getTotalRenderedFramesFromVideoElement", void 0);
        _define_property(this, "handleRenderedFramerateChanged", void 0);
        _define_property(this, "handleLoadFinished", void 0);
        this.playoutData = playoutData;
        this.advertBoltOns = advertBoltOns;
        this.playerEngineOptions = playerEngineOptions;
        this.logger = logger;
        this.configuration = configuration;
        this.debugConfig = debugConfig;
        this.precursor = precursor;
        this.state = PlayerState.WaitingToLoad;
        this.id = "EngItem-".concat("0000".concat(++BasePlayerEngineItem.idCount).slice(-4));
        this.errorContext = 'SDK.PEI';
        this.firstPositionUpdateSent = false;
        this.shouldIgnoreStateAndPositionChanges = false;
        this.stallDetector = null;
        this.isCurrentlyMuted = false;
        this.timedActionsScheduler = null;
        this.isLoading = false;
        this.isLoaded = false;
        this.modifiedBeforeLoad = {};
        this.hasBeenStopped = false;
        this.queuedEmsgEventIds = new Set();
        this.isOfficiallySeeking = false;
        this.notifyManifestParsed = function() {
            var _this_bulkTimedMetadataGatherer, _this_manifestParsedObservable;
            (_this_bulkTimedMetadataGatherer = _this.bulkTimedMetadataGatherer) === null || _this_bulkTimedMetadataGatherer === void 0 ? void 0 : _this_bulkTimedMetadataGatherer.flush();
            (_this_manifestParsedObservable = _this.manifestParsedObservable) === null || _this_manifestParsedObservable === void 0 ? void 0 : _this_manifestParsedObservable.notifyObservers();
        };
        this.notifyManifestUpdated = function() {
            var _this_bulkTimedMetadataGatherer, _this_manifestUpdatedObservable;
            (_this_bulkTimedMetadataGatherer = _this.bulkTimedMetadataGatherer) === null || _this_bulkTimedMetadataGatherer === void 0 ? void 0 : _this_bulkTimedMetadataGatherer.flush();
            (_this_manifestUpdatedObservable = _this.manifestUpdatedObservable) === null || _this_manifestUpdatedObservable === void 0 ? void 0 : _this_manifestUpdatedObservable.notifyObservers();
        };
        this.notifyPreSeekStarted = function() {
            var _this_preSeekStartedObservable;
            (_this_preSeekStartedObservable = _this.preSeekStartedObservable) === null || _this_preSeekStartedObservable === void 0 ? void 0 : _this_preSeekStartedObservable.notifyObservers();
        };
        this.scheduleEmsgEvent = function(event) {
            var _this_timedActionsScheduler;
            if (!checkIsManifestLinearType(_this.playoutData.type) || !event.presentationTime) {
                return;
            }
            var presentationTime = event.presentationTime, schemeIdUri = event.schemeIdUri, messageData = event.messageData, value = event.value;
            var combinedId = md5("".concat(presentationTime, "-").concat(messageData));
            if (_this.queuedEmsgEventIds.has(combinedId)) {
                return;
            }
            _this.queuedEmsgEventIds.add(combinedId);
            (_this_timedActionsScheduler = _this.timedActionsScheduler) === null || _this_timedActionsScheduler === void 0 ? void 0 : _this_timedActionsScheduler.schedule({
                time: event.presentationTime,
                action: _this.processEmsg,
                args: [
                    combinedId,
                    presentationTime,
                    schemeIdUri,
                    messageData,
                    value
                ],
                shouldApplyPositionTolerances: true
            });
        };
        this.processEmsg = function(id, presentationTime, schemeIdUri, messageData, value) {
            _this.queuedEmsgEventIds.delete(id);
            _this.notifyTimedMetadataReceived({
                type: TimedMetadataType.EMsg,
                presentationTime: presentationTime,
                schemeIdUri: schemeIdUri,
                messageData: messageData,
                value: value
            });
        };
        this.notifyAdBreakStarted = function(adBreak) {
            var _this_adBreakStartedObservable, _this_adPolicyManager;
            (_this_adBreakStartedObservable = _this.adBreakStartedObservable) === null || _this_adBreakStartedObservable === void 0 ? void 0 : _this_adBreakStartedObservable.reset();
            var managedAdBreak = adBreak;
            if (!_this.adPolicyManager) {
                var _this_adBreakStartedObservable1;
                (_this_adBreakStartedObservable1 = _this.adBreakStartedObservable) === null || _this_adBreakStartedObservable1 === void 0 ? void 0 : _this_adBreakStartedObservable1.notifyObservers(adBreak);
                return;
            }
            managedAdBreak = (_this_adPolicyManager = _this.adPolicyManager) === null || _this_adPolicyManager === void 0 ? void 0 : _this_adPolicyManager.manageAdBreakStarted(managedAdBreak);
            if (managedAdBreak) {
                var _this_adBreakStartedObservable2;
                (_this_adBreakStartedObservable2 = _this.adBreakStartedObservable) === null || _this_adBreakStartedObservable2 === void 0 ? void 0 : _this_adBreakStartedObservable2.notifyObservers(managedAdBreak);
            }
        };
        this.notifyAdBreakFinished = function(adBreak) {
            var _this_adBreakFinishedObservable;
            (_this_adBreakFinishedObservable = _this.adBreakFinishedObservable) === null || _this_adBreakFinishedObservable === void 0 ? void 0 : _this_adBreakFinishedObservable.reset();
            var managedAdBreak = adBreak;
            if (!_this.adPolicyManager) {
                var _this_adBreakFinishedObservable1;
                (_this_adBreakFinishedObservable1 = _this.adBreakFinishedObservable) === null || _this_adBreakFinishedObservable1 === void 0 ? void 0 : _this_adBreakFinishedObservable1.notifyObservers(adBreak);
                return;
            }
            // Note: Since we sourced the break from the ad policy manager, it must be cloned in order to retain the original watched status before ad policy manager mutates it
            var adBreakCopy = cloneAdBreak(adBreak);
            managedAdBreak = _this.adPolicyManager.manageAdBreakFinished(managedAdBreak);
            if (managedAdBreak) {
                var _this_adBreakFinishedObservable2;
                (_this_adBreakFinishedObservable2 = _this.adBreakFinishedObservable) === null || _this_adBreakFinishedObservable2 === void 0 ? void 0 : _this_adBreakFinishedObservable2.notifyObservers(adBreakCopy);
                if (!adBreakCopy.watched) {
                    // Note: Ad policy manager itself is source of truth for break data in this case, so we notify of watched status change here
                    _this.notifyAdBreakDataChanged();
                }
            }
        };
        this.notifyAdBreakDataChanged = function() {
            var _this_adBreakDataReceivedObservable, _this_adPolicyManager, _this_adBreakDataReceivedObservable1;
            (_this_adBreakDataReceivedObservable = _this.adBreakDataReceivedObservable) === null || _this_adBreakDataReceivedObservable === void 0 ? void 0 : _this_adBreakDataReceivedObservable.reset();
            var _this_adPolicyManager_getAdBreaks;
            (_this_adBreakDataReceivedObservable1 = _this.adBreakDataReceivedObservable) === null || _this_adBreakDataReceivedObservable1 === void 0 ? void 0 : _this_adBreakDataReceivedObservable1.notifyObservers((_this_adPolicyManager_getAdBreaks = (_this_adPolicyManager = _this.adPolicyManager) === null || _this_adPolicyManager === void 0 ? void 0 : _this_adPolicyManager.getAdBreaks()) !== null && _this_adPolicyManager_getAdBreaks !== void 0 ? _this_adPolicyManager_getAdBreaks : []);
        };
        this.notifyAdStarted = function(adData) {
            var _this_adStartedObservable;
            (_this_adStartedObservable = _this.adStartedObservable) === null || _this_adStartedObservable === void 0 ? void 0 : _this_adStartedObservable.reset();
            var managedAdData = adData;
            if (_this.adPolicyManager) {
                managedAdData = _this.adPolicyManager.manageAdStarted(managedAdData);
            }
            if (managedAdData) {
                var _this_adStartedObservable1;
                (_this_adStartedObservable1 = _this.adStartedObservable) === null || _this_adStartedObservable1 === void 0 ? void 0 : _this_adStartedObservable1.notifyObservers(managedAdData);
            }
        };
        this.notifyAdFinished = function(adData) {
            var _this_adFinishedObservable;
            (_this_adFinishedObservable = _this.adFinishedObservable) === null || _this_adFinishedObservable === void 0 ? void 0 : _this_adFinishedObservable.reset();
            var managedAdData = adData;
            if (_this.adPolicyManager) {
                managedAdData = _this.adPolicyManager.manageAdFinished(managedAdData);
            }
            if (managedAdData) {
                var _this_adFinishedObservable1;
                (_this_adFinishedObservable1 = _this.adFinishedObservable) === null || _this_adFinishedObservable1 === void 0 ? void 0 : _this_adFinishedObservable1.notifyObservers(managedAdData);
            }
        };
        this.recoverStallBySeeking = function(targetPosition) {
            _this.triggerSeek(targetPosition);
        };
        this.addPrimaryLanguageFlag = function(tracks) {
            var mainTracks = tracks.filter(function(t) {
                var _t_roles;
                return (_t_roles = t.roles) === null || _t_roles === void 0 ? void 0 : _t_roles.includes(AudioRole.Main);
            });
            if (mainTracks.length === 1) {
                mainTracks[0].isPrimaryLanguage = true;
            }
            return tracks;
        };
        this.getTotalRenderedFramesFromVideoElement = function(videoElement) {
            var _videoElement_getVideoPlaybackQuality, _videoElement_getVideoPlaybackQuality1;
            return videoElement === null || videoElement === void 0 ? void 0 : (_videoElement_getVideoPlaybackQuality1 = videoElement.getVideoPlaybackQuality) === null || _videoElement_getVideoPlaybackQuality1 === void 0 ? void 0 : (_videoElement_getVideoPlaybackQuality = _videoElement_getVideoPlaybackQuality1.call(videoElement)) === null || _videoElement_getVideoPlaybackQuality === void 0 ? void 0 : _videoElement_getVideoPlaybackQuality.totalVideoFrames;
        };
        this.handleRenderedFramerateChanged = function(getTotalRenderedFrames) {
            var framerateCaptureIntervalSeconds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
            var _this_renderedFrameRateInterval;
            var lastVideoFrames = 0;
            (_this_renderedFrameRateInterval = _this1.renderedFrameRateInterval) === null || _this_renderedFrameRateInterval === void 0 ? void 0 : _this_renderedFrameRateInterval.stop();
            _this1.renderedFrameRateInterval = new SafeInterval({
                executor: function(elapsedTimeMs) {
                    var totalRenderedFrames = getTotalRenderedFrames();
                    if (totalRenderedFrames !== undefined && _this1.state === PlayerState.Playing) {
                        if (lastVideoFrames) {
                            var fps = Math.max(totalRenderedFrames - lastVideoFrames, 0) / (elapsedTimeMs / 1000);
                            _this1.notifyRenderedFrameRateChanged(fps);
                        }
                        lastVideoFrames = totalRenderedFrames;
                    }
                },
                timeMs: framerateCaptureIntervalSeconds * 1000
            });
            _this1.renderedFrameRateInterval.start();
        };
        this.handleLoadFinished = function() {
            perfLogger.measure(PerfKey.root, PerfTag.nativeLoadEnd);
            perfLogger.measure(PerfKey.nativeLoad, PerfTag.nativeLoadEnd);
            _this.isLoading = false;
            _this.isLoaded = true;
            if (_this.isActive()) {
                var _this_modifiedBeforeLoad = _this.modifiedBeforeLoad, volume = _this_modifiedBeforeLoad.volume, isMuted = _this_modifiedBeforeLoad.isMuted, playoutRect = _this_modifiedBeforeLoad.playoutRect;
                if (isMuted !== undefined) {
                    _this.setMute(isMuted);
                }
                if (volume !== undefined) {
                    _this.setVolume(volume);
                }
                if (playoutRect !== undefined) {
                    _this.setPlayoutRect(playoutRect);
                }
                _this.modifiedBeforeLoad = {};
            }
        };
        var _this_advertBoltOns = this.advertBoltOns, adBreakTimeAdapter = _this_advertBoltOns.adBreakTimeAdapter, policyManager = _this_advertBoltOns.policyManager, eventsManager = _this_advertBoltOns.eventsManager, breaksProvider = _this_advertBoltOns.breaksProvider, timedActionsScheduler = _this_advertBoltOns.timedActionsScheduler, transition = _this_advertBoltOns.transition;
        this.currentPosition = playoutData.position || 0;
        this.initialiseLoggerObservables();
        this.adBreakTimeAdapter = adBreakTimeAdapter;
        this.adBreaksProvider = breaksProvider;
        this.adPolicyManager = policyManager;
        this.adEventsManager = eventsManager;
        this.timedActionsScheduler = timedActionsScheduler;
        if (!this.timedActionsScheduler) {
            this.timedActionsScheduler = new TimedActionsScheduler();
        }
        this.seekDataManager = new SeekDataManager();
        this.bufferAnalyser = new BufferAnalyser((_this_debugConfig = this.debugConfig) === null || _this_debugConfig === void 0 ? void 0 : _this_debugConfig.bufferGapDetectionSeverity, this.playoutData, function(err) {
            return _this.notifyError(CvsdkError.from(_object_spread_props(_object_spread({}, err), {
                code: "".concat(_this.errorContext, ".BUFFER_GAP_DETECTED")
            })));
        }, this.logger);
        if (playoutData.adInsertionConfig) {
            this.attachToAdEventsManager(eventsManager, playoutData.adInsertionConfig);
        }
        this.tryInitializeBulkTimedMetadataGatherer(playerExtensions);
        this.tryInitializeThumbnailManager(playerExtensions);
        this.bandwidthEstimator = CoreVideoInternal.bandwidthEstimator;
        this.tryInitializeStallDetector(playerExtensions);
        this.tryInitializeSubtitlesManager(playerExtensions);
        this.tryInitializeDashManifestDownloader(playerExtensions);
        transition === null || transition === void 0 ? void 0 : transition.onAdTransition(function() {
            return _this.notifySubtitleCuesChanged([]);
        });
        policyManager === null || policyManager === void 0 ? void 0 : policyManager.onShouldSeek(function(position) {
            _this.seekDataManager.update({
                from: _this.currentPosition,
                to: undefined,
                toManaged: position
            });
            _this.triggerSeek(_this.seekDataManager.to);
        });
        if (configuration === null || configuration === void 0 ? void 0 : configuration.hasOwnPositionManagement) {
            return;
        }
        this.interpolatedPosition = this.buildInterpolation();
    }
    _create_class(BasePlayerEngineItem, [
        {
            key: "tryInitializeBulkTimedMetadataGatherer",
            value: function tryInitializeBulkTimedMetadataGatherer(playerExtensions) {
                if (playerExtensions === null || playerExtensions === void 0 ? void 0 : playerExtensions.bulkTimedMetadataGatherer) {
                    this.bulkTimedMetadataGatherer = playerExtensions.bulkTimedMetadataGatherer;
                    this.bulkTimedMetadataGatherer.onBulkData(this.notifyBulkTimedMetadataReceived.bind(this));
                }
            }
        },
        {
            key: "tryInitializeDashManifestDownloader",
            value: function tryInitializeDashManifestDownloader(playerExtensions) {
                var _this = this;
                if (playerExtensions === null || playerExtensions === void 0 ? void 0 : playerExtensions.dashManifestDownloader) {
                    this.dashManifestDownloader = playerExtensions.dashManifestDownloader;
                    if ((playerExtensions === null || playerExtensions === void 0 ? void 0 : playerExtensions.subtitlesManager) && this.subtitlesManager) {
                        this.dashManifestDownloader.onManifestDownloaded(this.subtitlesManager.handleManifestDownloaded.bind(this.subtitlesManager));
                    }
                    if ((playerExtensions === null || playerExtensions === void 0 ? void 0 : playerExtensions.thumbnailManager) && this.thumbnailManager) {
                        this.dashManifestDownloader.onManifestDownloaded(this.thumbnailManager.handlePlayerLoaded.bind(this.thumbnailManager));
                    }
                    this.waitForState([
                        PlayerState.Playing,
                        PlayerState.Paused
                    ]).then(function() {
                        var _this_dashManifestDownloader;
                        return (_this_dashManifestDownloader = _this.dashManifestDownloader) === null || _this_dashManifestDownloader === void 0 ? void 0 : _this_dashManifestDownloader.init();
                    }).catch(function(e) {
                        return _this.logger.warn("waitForState failed for reason: ".concat(JsonUtils.stringify(e)));
                    });
                }
            }
        },
        {
            key: "tryInitializeStallDetector",
            value: function tryInitializeStallDetector(playerExtensions) {
                if (playerExtensions === null || playerExtensions === void 0 ? void 0 : playerExtensions.stallDetector) {
                    this.stallDetector = playerExtensions.stallDetector;
                    this.stallDetector.onStallDetected(this.recoverStallBySeeking);
                }
            }
        },
        {
            key: "tryInitializeSubtitlesManager",
            value: function tryInitializeSubtitlesManager(playerExtensions) {
                var _this = this;
                if (playerExtensions === null || playerExtensions === void 0 ? void 0 : playerExtensions.subtitlesManager) {
                    this.subtitlesManager = playerExtensions.subtitlesManager;
                    this.subtitlesManager.onSubtitleCuesChanged(this.notifySubtitleCuesChanged, this);
                    this.subtitlesManager.onSubtitlesTrackChanged(this.notifySubtitlesTrackChanged, this);
                    this.subtitlesManager.onAvailableSubtitlesTracksChanged(this.notifyAvailableSubtitlesTracksChanged, this);
                    this.waitForState([
                        PlayerState.Playing,
                        PlayerState.Paused
                    ]).then(function() {
                        var _this_subtitlesManager;
                        return (_this_subtitlesManager = _this.subtitlesManager) === null || _this_subtitlesManager === void 0 ? void 0 : _this_subtitlesManager.handlePlayerLoaded();
                    }).catch(function(e) {
                        return _this.logger.warn("waitForState failed for reason: ".concat(JsonUtils.stringify(e)));
                    });
                }
            }
        },
        {
            key: "tryInitializeThumbnailManager",
            value: function tryInitializeThumbnailManager(playerExtensions) {
                var _this = this;
                if (playerExtensions === null || playerExtensions === void 0 ? void 0 : playerExtensions.thumbnailManager) {
                    this.thumbnailManager = playerExtensions.thumbnailManager;
                    this.thumbnailManager.onAvailableThumbnailVariantsChanged(this.notifyAvailableThumbnailVariantsChanged, this);
                    this.waitForState([
                        PlayerState.Playing,
                        PlayerState.Paused
                    ]).then(function() {
                        var _this_thumbnailManager;
                        (_this_thumbnailManager = _this.thumbnailManager) === null || _this_thumbnailManager === void 0 ? void 0 : _this_thumbnailManager.handlePlayerLoaded();
                    }).catch(function(e) {
                        _this.logger.warn("waitForState failed for reason: ".concat(JsonUtils.stringify(e)));
                    });
                }
            }
        },
        {
            key: "attachToAdEventsManager",
            value: function attachToAdEventsManager(eventsManager, adInsertionConfig) {
                var _this_adBreaksProvider;
                if (adInsertionConfig.adInsertionStrategy === AdInsertionStrategy.SSAI && adInsertionConfig.isPlayerAdBreakDataRequired) {
                    var _this_adEventsManager;
                    (_this_adEventsManager = this.adEventsManager) === null || _this_adEventsManager === void 0 ? void 0 : _this_adEventsManager.onAdBreakDataChanged(this.notifyAdBreakDataReceived, this);
                }
                if (eventsManager && adInsertionConfig.isPlayerAdEventsRequired) {
                    eventsManager.onAdStarted(this.notifyAdStarted, this);
                    eventsManager.onAdFinished(this.notifyAdFinished, this);
                    eventsManager.onAdBreakStarted(this.notifyAdBreakStarted, this);
                    eventsManager.onAdBreakFinished(this.notifyAdBreakFinished, this);
                }
                (_this_adBreaksProvider = this.adBreaksProvider) === null || _this_adBreaksProvider === void 0 ? void 0 : _this_adBreaksProvider.onError(this.notifyWarning, this);
            }
        },
        {
            key: "load",
            value: function load() {
                var _this = this;
                var _this_durationObservable, _this_availableAudioTracksObservable, _this_availableSubtitlesTracksObservable, _this_bitrateObservable, _this_encodedFrameRateObservable, _this_renderedFrameRateObservable;
                if (this.hasCalledLoad()) {
                    throw new Error('Engine item was previously loaded');
                }
                this.isLoading = true;
                (_this_durationObservable = this.durationObservable) === null || _this_durationObservable === void 0 ? void 0 : _this_durationObservable.registerObserver(function(duration) {
                    _this.duration = duration;
                }, this);
                (_this_availableAudioTracksObservable = this.availableAudioTracksObservable) === null || _this_availableAudioTracksObservable === void 0 ? void 0 : _this_availableAudioTracksObservable.registerObserver(function(tracks) {
                    _this.availableAudioTracks = tracks;
                }, this);
                (_this_availableSubtitlesTracksObservable = this.availableSubtitlesTracksObservable) === null || _this_availableSubtitlesTracksObservable === void 0 ? void 0 : _this_availableSubtitlesTracksObservable.registerObserver(function(tracks) {
                    _this.availableTextTracks = tracks;
                }, this);
                (_this_bitrateObservable = this.bitrateObservable) === null || _this_bitrateObservable === void 0 ? void 0 : _this_bitrateObservable.registerObserver(function(bitrate) {
                    _this.currentBitrate = bitrate;
                }, this);
                (_this_encodedFrameRateObservable = this.encodedFrameRateObservable) === null || _this_encodedFrameRateObservable === void 0 ? void 0 : _this_encodedFrameRateObservable.registerObserver(function(frameRate) {
                    _this.currentEncodedFrameRate = frameRate;
                }, this);
                (_this_renderedFrameRateObservable = this.renderedFrameRateObservable) === null || _this_renderedFrameRateObservable === void 0 ? void 0 : _this_renderedFrameRateObservable.registerObserver(function(frameRate) {
                    _this.currentRenderedFrameRate = frameRate;
                }, this);
                perfLogger.measure(PerfKey.root, PerfTag.nativeLoadStart);
                perfLogger.measure(PerfKey.nativeLoad, PerfTag.nativeLoadStart);
                this.nativeLoad(this.playoutData).then(this.handleLoadFinished);
            }
        },
        {
            key: "setVisibility",
            value: function setVisibility(visible) {}
        },
        {
            key: "setActiveManifest",
            value: // noop
            function setActiveManifest(manifest) {}
        },
        {
            key: "onStateChanged",
            value: // noop
            function onStateChanged(callback, callbackOwner, priority) {
                var _this_gatedPlayerStateObservable;
                (_this_gatedPlayerStateObservable = this.gatedPlayerStateObservable) === null || _this_gatedPlayerStateObservable === void 0 ? void 0 : _this_gatedPlayerStateObservable.registerObserver(callback, callbackOwner, {
                    priority: priority
                });
            }
        },
        {
            key: "onPlayStart",
            value: function onPlayStart(callback, callbackOwner) {
                var _this_playStartObservable;
                (_this_playStartObservable = this.playStartObservable) === null || _this_playStartObservable === void 0 ? void 0 : _this_playStartObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onPreSeekStarted",
            value: function onPreSeekStarted(callback, callbackOwner) {
                var _this_preSeekStartedObservable;
                (_this_preSeekStartedObservable = this.preSeekStartedObservable) === null || _this_preSeekStartedObservable === void 0 ? void 0 : _this_preSeekStartedObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onSeekStarted",
            value: function onSeekStarted(callback, callbackOwner) {
                var _this_seekStartedObservable;
                (_this_seekStartedObservable = this.seekStartedObservable) === null || _this_seekStartedObservable === void 0 ? void 0 : _this_seekStartedObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onSeekEnded",
            value: function onSeekEnded(callback, callbackOwner) {
                var _this_seekEndedObservable;
                (_this_seekEndedObservable = this.seekEndedObservable) === null || _this_seekEndedObservable === void 0 ? void 0 : _this_seekEndedObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onHttpRequestChanged",
            value: function onHttpRequestChanged(callback, callbackOwner) {
                var _this_httpRequestObservable;
                (_this_httpRequestObservable = this.httpRequestObservable) === null || _this_httpRequestObservable === void 0 ? void 0 : _this_httpRequestObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onHttpResponseChanged",
            value: function onHttpResponseChanged(callback, callbackOwner) {
                var _this_httpResponseObservable;
                (_this_httpResponseObservable = this.httpResponseObservable) === null || _this_httpResponseObservable === void 0 ? void 0 : _this_httpResponseObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onBitrateChanged",
            value: function onBitrateChanged(callback, callbackOwner) {
                var _this_bitrateObservable;
                (_this_bitrateObservable = this.bitrateObservable) === null || _this_bitrateObservable === void 0 ? void 0 : _this_bitrateObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onEncodedFrameRateChanged",
            value: function onEncodedFrameRateChanged(callback, callbackOwner) {
                var _this_encodedFrameRateObservable;
                (_this_encodedFrameRateObservable = this.encodedFrameRateObservable) === null || _this_encodedFrameRateObservable === void 0 ? void 0 : _this_encodedFrameRateObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onRenderedFrameRateChanged",
            value: function onRenderedFrameRateChanged(callback, callbackOwner) {
                var _this_renderedFrameRateObservable;
                (_this_renderedFrameRateObservable = this.renderedFrameRateObservable) === null || _this_renderedFrameRateObservable === void 0 ? void 0 : _this_renderedFrameRateObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onVideoTrackChanged",
            value: function onVideoTrackChanged(callback, callbackOwner) {
                var // @ts-ignore
                _this_videoTrackChangedObservable;
                (_this_videoTrackChangedObservable = this.videoTrackChangedObservable) === null || _this_videoTrackChangedObservable === void 0 ? void 0 : _this_videoTrackChangedObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onPositionChanged",
            value: function onPositionChanged(callback, callbackOwner) {
                var _this_currentPositionObservable;
                (_this_currentPositionObservable = this.currentPositionObservable) === null || _this_currentPositionObservable === void 0 ? void 0 : _this_currentPositionObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onDurationChanged",
            value: function onDurationChanged(callback, callbackOwner) {
                var _this_durationObservable;
                (_this_durationObservable = this.durationObservable) === null || _this_durationObservable === void 0 ? void 0 : _this_durationObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onAvailableAudioTracksChanged",
            value: function onAvailableAudioTracksChanged(callback, callbackOwner) {
                var _this_availableAudioTracksObservable;
                (_this_availableAudioTracksObservable = this.availableAudioTracksObservable) === null || _this_availableAudioTracksObservable === void 0 ? void 0 : _this_availableAudioTracksObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onAvailableSubtitlesTracksChanged",
            value: function onAvailableSubtitlesTracksChanged(callback, callbackOwner) {
                var _this_availableSubtitlesTracksObservable;
                (_this_availableSubtitlesTracksObservable = this.availableSubtitlesTracksObservable) === null || _this_availableSubtitlesTracksObservable === void 0 ? void 0 : _this_availableSubtitlesTracksObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onAvailableThumbnailVariantsChanged",
            value: function onAvailableThumbnailVariantsChanged(callback, callbackOwner) {
                var _this_availableThumbnailVariantsObservable;
                (_this_availableThumbnailVariantsObservable = this.availableThumbnailVariantsObservable) === null || _this_availableThumbnailVariantsObservable === void 0 ? void 0 : _this_availableThumbnailVariantsObservable.registerObserver(callback, callbackOwner, {
                    renotifyLastEvent: true
                });
            }
        },
        {
            key: "onError",
            value: function onError(callback, callbackOwner) {
                var _this_errorObservable;
                (_this_errorObservable = this.errorObservable) === null || _this_errorObservable === void 0 ? void 0 : _this_errorObservable.registerObserver(callback, callbackOwner, {
                    renotifyLastEvent: true
                });
            }
        },
        {
            key: "onWarning",
            value: function onWarning(callback, callbackOwner) {
                var _this_warningObservable;
                (_this_warningObservable = this.warningObservable) === null || _this_warningObservable === void 0 ? void 0 : _this_warningObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onStreamMetadataReceived",
            value: // TODO Specific to Sky Europe, remove streamMetadata, surface raw data through timedMetadata and do parsing at higher level
            function onStreamMetadataReceived(callback, callbackOwner) {
                var _this_streamMetadataObservable;
                (_this_streamMetadataObservable = this.streamMetadataObservable) === null || _this_streamMetadataObservable === void 0 ? void 0 : _this_streamMetadataObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onTimedMetadataReceived",
            value: function onTimedMetadataReceived(callback, callbackOwner) {
                var _this_timedMetadataObservable;
                (_this_timedMetadataObservable = this.timedMetadataObservable) === null || _this_timedMetadataObservable === void 0 ? void 0 : _this_timedMetadataObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onBulkTimedMetadataReceived",
            value: function onBulkTimedMetadataReceived(callback, callbackOwner) {
                if (CoreVideoInternal.playerCapabilities.emitsBulkTimedMetadata) {
                    var _this_bulkTimedMetadataObservable;
                    (_this_bulkTimedMetadataObservable = this.bulkTimedMetadataObservable) === null || _this_bulkTimedMetadataObservable === void 0 ? void 0 : _this_bulkTimedMetadataObservable.registerObserver(callback, callbackOwner);
                } else {
                    throw new Error('Player does not emit bulk timed metadata.');
                }
            }
        },
        {
            key: "onAudioTrackChanged",
            value: function onAudioTrackChanged(callback, callbackOwner) {
                var _this_currentAudioTrackObservable;
                (_this_currentAudioTrackObservable = this.currentAudioTrackObservable) === null || _this_currentAudioTrackObservable === void 0 ? void 0 : _this_currentAudioTrackObservable.registerObserver(callback, callbackOwner, {
                    renotifyLastEvent: true
                });
            }
        },
        {
            key: "onSubtitlesTrackChanged",
            value: function onSubtitlesTrackChanged(callback, callbackOwner) {
                var _this_currentSubtitlesTrackObservable;
                (_this_currentSubtitlesTrackObservable = this.currentSubtitlesTrackObservable) === null || _this_currentSubtitlesTrackObservable === void 0 ? void 0 : _this_currentSubtitlesTrackObservable.registerObserver(callback, callbackOwner, {
                    renotifyLastEvent: true
                });
            }
        },
        {
            key: "onSubtitleCuesChanged",
            value: function onSubtitleCuesChanged(callback, callbackOwner) {
                var _this_subtitleCuesObservable;
                (_this_subtitleCuesObservable = this.subtitleCuesObservable) === null || _this_subtitleCuesObservable === void 0 ? void 0 : _this_subtitleCuesObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onVolumeChanged",
            value: function onVolumeChanged(callback, callbackOwner) {
                var _this_volumeObservable;
                (_this_volumeObservable = this.volumeObservable) === null || _this_volumeObservable === void 0 ? void 0 : _this_volumeObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onMuteChanged",
            value: function onMuteChanged(callback, callbackOwner) {
                var _this_muteObservable;
                (_this_muteObservable = this.muteObservable) === null || _this_muteObservable === void 0 ? void 0 : _this_muteObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onAutoPlayPolicyPreventedPlayback",
            value: function onAutoPlayPolicyPreventedPlayback(callback, callbackOwner) {
                var _this_autoPlayPolicyPreventedPlaybackObservable;
                (_this_autoPlayPolicyPreventedPlaybackObservable = this.autoPlayPolicyPreventedPlaybackObservable) === null || _this_autoPlayPolicyPreventedPlaybackObservable === void 0 ? void 0 : _this_autoPlayPolicyPreventedPlaybackObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onAdStarted",
            value: function onAdStarted(callback, callbackOwner) {
                var _this_adStartedObservable;
                (_this_adStartedObservable = this.adStartedObservable) === null || _this_adStartedObservable === void 0 ? void 0 : _this_adStartedObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onAdFinished",
            value: function onAdFinished(callback, callbackOwner) {
                var _this_adFinishedObservable;
                (_this_adFinishedObservable = this.adFinishedObservable) === null || _this_adFinishedObservable === void 0 ? void 0 : _this_adFinishedObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onAdBreakStarted",
            value: function onAdBreakStarted(callback, callbackOwner) {
                var _this_adBreakStartedObservable;
                (_this_adBreakStartedObservable = this.adBreakStartedObservable) === null || _this_adBreakStartedObservable === void 0 ? void 0 : _this_adBreakStartedObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onAdBreakFinished",
            value: function onAdBreakFinished(callback, callbackOwner) {
                var _this_adBreakFinishedObservable;
                (_this_adBreakFinishedObservable = this.adBreakFinishedObservable) === null || _this_adBreakFinishedObservable === void 0 ? void 0 : _this_adBreakFinishedObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onAdBreakDataReceived",
            value: function onAdBreakDataReceived(callback, callbackOwner) {
                var _this_adBreakDataReceivedObservable;
                (_this_adBreakDataReceivedObservable = this.adBreakDataReceivedObservable) === null || _this_adBreakDataReceivedObservable === void 0 ? void 0 : _this_adBreakDataReceivedObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onAdPositionUpdate",
            value: function onAdPositionUpdate(callback, callbackOwner) {
                var _this_adPositionObservable;
                (_this_adPositionObservable = this.adPositionObservable) === null || _this_adPositionObservable === void 0 ? void 0 : _this_adPositionObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onCdnSwitch",
            value: function onCdnSwitch(callback, callbackOwner) {
                var _this_cdnSwitchObservable;
                (_this_cdnSwitchObservable = this.cdnSwitchObservable) === null || _this_cdnSwitchObservable === void 0 ? void 0 : _this_cdnSwitchObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onManifestParsed",
            value: function onManifestParsed(callback, callbackOwner) {
                var _this_manifestParsedObservable;
                (_this_manifestParsedObservable = this.manifestParsedObservable) === null || _this_manifestParsedObservable === void 0 ? void 0 : _this_manifestParsedObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onManifestUpdated",
            value: function onManifestUpdated(callback, callbackOwner) {
                var _this_manifestUpdatedObservable;
                (_this_manifestUpdatedObservable = this.manifestUpdatedObservable) === null || _this_manifestUpdatedObservable === void 0 ? void 0 : _this_manifestUpdatedObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onManifestReceived",
            value: function onManifestReceived(callback, callbackOwner) {
                var _this_manifestReceivedObservable;
                (_this_manifestReceivedObservable = this.manifestReceivedObservable) === null || _this_manifestReceivedObservable === void 0 ? void 0 : _this_manifestReceivedObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onUserStopped",
            value: function onUserStopped(callback, callbackOwner) {
                var _this_userStoppedObservable;
                (_this_userStoppedObservable = this.userStoppedObservable) === null || _this_userStoppedObservable === void 0 ? void 0 : _this_userStoppedObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onLiveWindowUpdate",
            value: function onLiveWindowUpdate(callback, callbackOwner) {
                var _this_liveWindowChangedObservable;
                (_this_liveWindowChangedObservable = this.liveWindowChangedObservable) === null || _this_liveWindowChangedObservable === void 0 ? void 0 : _this_liveWindowChangedObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onVideoElementCreated",
            value: function onVideoElementCreated(callback, callbackOwner) {
                var _this_videoElementCreatedObservable;
                (_this_videoElementCreatedObservable = this.videoElementCreatedObservable) === null || _this_videoElementCreatedObservable === void 0 ? void 0 : _this_videoElementCreatedObservable.registerObserver(callback, callbackOwner, {
                    renotifyLastEvent: true
                });
            }
        },
        {
            key: "onFullscreenChanged",
            value: function onFullscreenChanged(callback, callbackOwner) {
                var _this_fullscreenChangedObservable;
                (_this_fullscreenChangedObservable = this.fullscreenChangedObservable) === null || _this_fullscreenChangedObservable === void 0 ? void 0 : _this_fullscreenChangedObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onClicked",
            value: function onClicked(callback, callbackOwner) {
                var _this_clickedObservable;
                (_this_clickedObservable = this.clickedObservable) === null || _this_clickedObservable === void 0 ? void 0 : _this_clickedObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "onStopped",
            value: function onStopped(callback, callbackOwner) {
                this.registerStateObserver(PlayerState.Stopped, callback, callbackOwner);
            }
        },
        {
            key: "onLoading",
            value: function onLoading(callback, callbackOwner) {
                this.registerStateObserver(PlayerState.Loading, callback, callbackOwner);
            }
        },
        {
            key: "onPlaying",
            value: function onPlaying(callback, callbackOwner) {
                this.registerStateObserver(PlayerState.Playing, callback, callbackOwner);
            }
        },
        {
            key: "onPaused",
            value: function onPaused(callback, callbackOwner) {
                this.registerStateObserver(PlayerState.Paused, callback, callbackOwner);
            }
        },
        {
            key: "onRebuffering",
            value: function onRebuffering(callback, callbackOwner) {
                this.registerStateObserver(PlayerState.Rebuffering, callback, callbackOwner);
            }
        },
        {
            key: "onSeeking",
            value: function onSeeking(callback, callbackOwner) {
                this.registerStateObserver(PlayerState.Seeking, callback, callbackOwner);
            }
        },
        {
            key: "onFinished",
            value: function onFinished(callback, callbackOwner) {
                this.registerStateObserver(PlayerState.Finished, callback, callbackOwner);
            }
        },
        {
            key: "removeEventListeners",
            value: // eslint-disable-next-line complexity -- Method is long but is simply a sequence of unregistering observables
            function removeEventListeners(callbackOwner) {
                var _this_gatedPlayerStateObservable, _this_internalPlayerStateObservable, _this_seekStartedObservable, _this_seekEndedObservable, _this_playStartObservable, _this_bitrateObservable, _this_videoTrackChangedObservable, _this_currentPositionObservable, _this_durationObservable, _this_availableAudioTracksObservable, _this_availableSubtitlesTracksObservable, _this_availableThumbnailVariantsObservable, _this_errorObservable, _this_warningObservable, _this_streamMetadataObservable, _this_currentAudioTrackObservable, _this_currentSubtitlesTrackObservable, _this_subtitleCuesObservable, _this_volumeObservable, _this_cdnSwitchObservable, _this_manifestReceivedObservable, _this_userStoppedObservable, _this_manifestParsedObservable, _this_manifestUpdatedObservable, _this_videoElementCreatedObservable, _this_fullscreenChangedObservable, _this_clickedObservable, _this_autoPlayPolicyPreventedPlaybackObservable, _this_encodedFrameRateObservable, _this_renderedFrameRateObservable, _this_preSeekStartedObservable, _this_timedMetadataObservable, _this_bulkTimedMetadataObservable, _this_muteObservable, _this_adStartedObservable, _this_adFinishedObservable, _this_adBreakStartedObservable, _this_adBreakFinishedObservable, _this_adBreakDataReceivedObservable, _this_adErrorObservable, _this_adPositionObservable, _this_liveWindowChangedObservable, _this_httpRequestObservable, _this_httpResponseObservable;
                (_this_gatedPlayerStateObservable = this.gatedPlayerStateObservable) === null || _this_gatedPlayerStateObservable === void 0 ? void 0 : _this_gatedPlayerStateObservable.unregisterObservers(callbackOwner);
                (_this_internalPlayerStateObservable = this.internalPlayerStateObservable) === null || _this_internalPlayerStateObservable === void 0 ? void 0 : _this_internalPlayerStateObservable.unregisterObservers(callbackOwner);
                (_this_seekStartedObservable = this.seekStartedObservable) === null || _this_seekStartedObservable === void 0 ? void 0 : _this_seekStartedObservable.unregisterObservers(callbackOwner);
                (_this_seekEndedObservable = this.seekEndedObservable) === null || _this_seekEndedObservable === void 0 ? void 0 : _this_seekEndedObservable.unregisterObservers(callbackOwner);
                (_this_playStartObservable = this.playStartObservable) === null || _this_playStartObservable === void 0 ? void 0 : _this_playStartObservable.unregisterObservers(callbackOwner);
                (_this_bitrateObservable = this.bitrateObservable) === null || _this_bitrateObservable === void 0 ? void 0 : _this_bitrateObservable.unregisterObservers(callbackOwner);
                (_this_videoTrackChangedObservable = this.videoTrackChangedObservable) === null || _this_videoTrackChangedObservable === void 0 ? void 0 : _this_videoTrackChangedObservable.unregisterObservers(callbackOwner);
                (_this_currentPositionObservable = this.currentPositionObservable) === null || _this_currentPositionObservable === void 0 ? void 0 : _this_currentPositionObservable.unregisterObservers(callbackOwner);
                (_this_durationObservable = this.durationObservable) === null || _this_durationObservable === void 0 ? void 0 : _this_durationObservable.unregisterObservers(callbackOwner);
                (_this_availableAudioTracksObservable = this.availableAudioTracksObservable) === null || _this_availableAudioTracksObservable === void 0 ? void 0 : _this_availableAudioTracksObservable.unregisterObservers(callbackOwner);
                (_this_availableSubtitlesTracksObservable = this.availableSubtitlesTracksObservable) === null || _this_availableSubtitlesTracksObservable === void 0 ? void 0 : _this_availableSubtitlesTracksObservable.unregisterObservers(callbackOwner);
                (_this_availableThumbnailVariantsObservable = this.availableThumbnailVariantsObservable) === null || _this_availableThumbnailVariantsObservable === void 0 ? void 0 : _this_availableThumbnailVariantsObservable.unregisterObservers(callbackOwner);
                (_this_errorObservable = this.errorObservable) === null || _this_errorObservable === void 0 ? void 0 : _this_errorObservable.unregisterObservers(callbackOwner);
                (_this_warningObservable = this.warningObservable) === null || _this_warningObservable === void 0 ? void 0 : _this_warningObservable.unregisterObservers(callbackOwner);
                (_this_streamMetadataObservable = this.streamMetadataObservable) === null || _this_streamMetadataObservable === void 0 ? void 0 : _this_streamMetadataObservable.unregisterObservers(callbackOwner);
                (_this_currentAudioTrackObservable = this.currentAudioTrackObservable) === null || _this_currentAudioTrackObservable === void 0 ? void 0 : _this_currentAudioTrackObservable.unregisterObservers(callbackOwner);
                (_this_currentSubtitlesTrackObservable = this.currentSubtitlesTrackObservable) === null || _this_currentSubtitlesTrackObservable === void 0 ? void 0 : _this_currentSubtitlesTrackObservable.unregisterObservers(callbackOwner);
                (_this_subtitleCuesObservable = this.subtitleCuesObservable) === null || _this_subtitleCuesObservable === void 0 ? void 0 : _this_subtitleCuesObservable.unregisterObservers(callbackOwner);
                (_this_volumeObservable = this.volumeObservable) === null || _this_volumeObservable === void 0 ? void 0 : _this_volumeObservable.unregisterObservers(callbackOwner);
                (_this_cdnSwitchObservable = this.cdnSwitchObservable) === null || _this_cdnSwitchObservable === void 0 ? void 0 : _this_cdnSwitchObservable.unregisterObservers(callbackOwner);
                (_this_manifestReceivedObservable = this.manifestReceivedObservable) === null || _this_manifestReceivedObservable === void 0 ? void 0 : _this_manifestReceivedObservable.unregisterObservers(callbackOwner);
                (_this_userStoppedObservable = this.userStoppedObservable) === null || _this_userStoppedObservable === void 0 ? void 0 : _this_userStoppedObservable.unregisterObservers(callbackOwner);
                (_this_manifestParsedObservable = this.manifestParsedObservable) === null || _this_manifestParsedObservable === void 0 ? void 0 : _this_manifestParsedObservable.unregisterObservers(callbackOwner);
                (_this_manifestUpdatedObservable = this.manifestUpdatedObservable) === null || _this_manifestUpdatedObservable === void 0 ? void 0 : _this_manifestUpdatedObservable.unregisterObservers(callbackOwner);
                (_this_videoElementCreatedObservable = this.videoElementCreatedObservable) === null || _this_videoElementCreatedObservable === void 0 ? void 0 : _this_videoElementCreatedObservable.unregisterObservers(callbackOwner);
                (_this_fullscreenChangedObservable = this.fullscreenChangedObservable) === null || _this_fullscreenChangedObservable === void 0 ? void 0 : _this_fullscreenChangedObservable.unregisterObservers(callbackOwner);
                (_this_clickedObservable = this.clickedObservable) === null || _this_clickedObservable === void 0 ? void 0 : _this_clickedObservable.unregisterObservers(callbackOwner);
                (_this_autoPlayPolicyPreventedPlaybackObservable = this.autoPlayPolicyPreventedPlaybackObservable) === null || _this_autoPlayPolicyPreventedPlaybackObservable === void 0 ? void 0 : _this_autoPlayPolicyPreventedPlaybackObservable.unregisterObservers(callbackOwner);
                (_this_encodedFrameRateObservable = this.encodedFrameRateObservable) === null || _this_encodedFrameRateObservable === void 0 ? void 0 : _this_encodedFrameRateObservable.unregisterObservers(callbackOwner);
                (_this_renderedFrameRateObservable = this.renderedFrameRateObservable) === null || _this_renderedFrameRateObservable === void 0 ? void 0 : _this_renderedFrameRateObservable.unregisterObservers(callbackOwner);
                (_this_preSeekStartedObservable = this.preSeekStartedObservable) === null || _this_preSeekStartedObservable === void 0 ? void 0 : _this_preSeekStartedObservable.unregisterObservers(callbackOwner);
                (_this_timedMetadataObservable = this.timedMetadataObservable) === null || _this_timedMetadataObservable === void 0 ? void 0 : _this_timedMetadataObservable.unregisterObservers(callbackOwner);
                (_this_bulkTimedMetadataObservable = this.bulkTimedMetadataObservable) === null || _this_bulkTimedMetadataObservable === void 0 ? void 0 : _this_bulkTimedMetadataObservable.unregisterObservers(callbackOwner);
                (_this_muteObservable = this.muteObservable) === null || _this_muteObservable === void 0 ? void 0 : _this_muteObservable.unregisterObservers(callbackOwner);
                (_this_adStartedObservable = this.adStartedObservable) === null || _this_adStartedObservable === void 0 ? void 0 : _this_adStartedObservable.unregisterObservers(callbackOwner);
                (_this_adFinishedObservable = this.adFinishedObservable) === null || _this_adFinishedObservable === void 0 ? void 0 : _this_adFinishedObservable.unregisterObservers(callbackOwner);
                (_this_adBreakStartedObservable = this.adBreakStartedObservable) === null || _this_adBreakStartedObservable === void 0 ? void 0 : _this_adBreakStartedObservable.unregisterObservers(callbackOwner);
                (_this_adBreakFinishedObservable = this.adBreakFinishedObservable) === null || _this_adBreakFinishedObservable === void 0 ? void 0 : _this_adBreakFinishedObservable.unregisterObservers(callbackOwner);
                (_this_adBreakDataReceivedObservable = this.adBreakDataReceivedObservable) === null || _this_adBreakDataReceivedObservable === void 0 ? void 0 : _this_adBreakDataReceivedObservable.unregisterObservers(callbackOwner);
                (_this_adErrorObservable = this.adErrorObservable) === null || _this_adErrorObservable === void 0 ? void 0 : _this_adErrorObservable.unregisterObservers(callbackOwner);
                (_this_adPositionObservable = this.adPositionObservable) === null || _this_adPositionObservable === void 0 ? void 0 : _this_adPositionObservable.unregisterObservers(callbackOwner);
                (_this_liveWindowChangedObservable = this.liveWindowChangedObservable) === null || _this_liveWindowChangedObservable === void 0 ? void 0 : _this_liveWindowChangedObservable.unregisterObservers(callbackOwner);
                (_this_httpRequestObservable = this.httpRequestObservable) === null || _this_httpRequestObservable === void 0 ? void 0 : _this_httpRequestObservable.unregisterObservers(callbackOwner);
                (_this_httpResponseObservable = this.httpResponseObservable) === null || _this_httpResponseObservable === void 0 ? void 0 : _this_httpResponseObservable.unregisterObservers(callbackOwner);
            }
        },
        {
            key: "resetErrorObservable",
            value: function resetErrorObservable() {
                var _this_errorObservable;
                (_this_errorObservable = this.errorObservable) === null || _this_errorObservable === void 0 ? void 0 : _this_errorObservable.reset();
            }
        },
        {
            key: "play",
            value: /***
     *
     * PLAYOUT SDK METHODS
     *
     ***/ function play() {
                this.ensurePlayerEngineItemActive(PlayerCommand.Play);
                this.nativePlay();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.ensurePlayerEngineItemActive(PlayerCommand.Pause);
                this.nativePause();
            }
        },
        {
            key: "stop",
            value: function stop(reason) {
                var _this = this;
                var _this_interpolatedPosition, _this_stallDetector, _this_dashManifestDownloader, _this_thumbnailManager, _this_thumbnailManager1, _this_adBreaksProvider, _this_adEventsManager, _this_subtitlesManager, _this_bulkTimedMetadataGatherer, _this_renderedFrameRateInterval, _this_videoElementCreatedObservable;
                this.ensurePlayerEngineItemActive(PlayerCommand.Stop);
                this.hasBeenStopped = true;
                (_this_interpolatedPosition = this.interpolatedPosition) === null || _this_interpolatedPosition === void 0 ? void 0 : _this_interpolatedPosition.destroy();
                (_this_stallDetector = this.stallDetector) === null || _this_stallDetector === void 0 ? void 0 : _this_stallDetector.destroy();
                this.stallDetector = null;
                (_this_dashManifestDownloader = this.dashManifestDownloader) === null || _this_dashManifestDownloader === void 0 ? void 0 : _this_dashManifestDownloader.destroy();
                (_this_thumbnailManager = this.thumbnailManager) === null || _this_thumbnailManager === void 0 ? void 0 : _this_thumbnailManager.destroy();
                (_this_thumbnailManager1 = this.thumbnailManager) === null || _this_thumbnailManager1 === void 0 ? void 0 : _this_thumbnailManager1.removeEventListeners(this);
                (_this_adBreaksProvider = this.adBreaksProvider) === null || _this_adBreaksProvider === void 0 ? void 0 : _this_adBreaksProvider.removeEventListeners(this);
                (_this_adEventsManager = this.adEventsManager) === null || _this_adEventsManager === void 0 ? void 0 : _this_adEventsManager.removeEventListeners(this);
                (_this_subtitlesManager = this.subtitlesManager) === null || _this_subtitlesManager === void 0 ? void 0 : _this_subtitlesManager.destroy();
                (_this_bulkTimedMetadataGatherer = this.bulkTimedMetadataGatherer) === null || _this_bulkTimedMetadataGatherer === void 0 ? void 0 : _this_bulkTimedMetadataGatherer.destroy();
                if (this.precursor) {
                    this.precursor.destroy().then(function() {
                        return _this.nativeStop();
                    }, function() {
                        return _this.nativeStop();
                    });
                } else {
                    this.nativeStop();
                }
                (_this_renderedFrameRateInterval = this.renderedFrameRateInterval) === null || _this_renderedFrameRateInterval === void 0 ? void 0 : _this_renderedFrameRateInterval.stop();
                this.timedActionsScheduler = null;
                (_this_videoElementCreatedObservable = this.videoElementCreatedObservable) === null || _this_videoElementCreatedObservable === void 0 ? void 0 : _this_videoElementCreatedObservable.reset();
            }
        },
        {
            key: "seek",
            value: function seek(positionSeconds) {
                var overrideSeekAllowedInAds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                this.ensurePlayerEngineItemActive(PlayerCommand.Seek);
                var managedSeekPosition = undefined;
                if (this.adPolicyManager && !overrideSeekAllowedInAds) {
                    var _this_seekDataManager_from;
                    managedSeekPosition = this.adPolicyManager.manageSeek((_this_seekDataManager_from = this.seekDataManager.from) !== null && _this_seekDataManager_from !== void 0 ? _this_seekDataManager_from : this.currentPosition, Math.ceil(positionSeconds));
                    // Seek blocked by ad policy
                    if (managedSeekPosition === null) {
                        return;
                    }
                }
                this.notifyPreSeekStarted();
                this.seekDataManager.update({
                    from: this.currentPosition,
                    to: positionSeconds,
                    toManaged: managedSeekPosition
                });
                return this.triggerSeek(this.seekDataManager.to, overrideSeekAllowedInAds);
            }
        },
        {
            key: "setAudioTrack",
            value: function setAudioTrack(audioTrackId) {
                this.ensurePlayerEngineItemActive(PlayerCommand.SetAudioTrack);
                this.nativeSetAudioTrack(audioTrackId);
            }
        },
        {
            key: "enableSubtitles",
            value: function enableSubtitles(subtitlesTrackId) {
                this.ensurePlayerEngineItemActive(PlayerCommand.EnableSubtitles);
                this.nativeEnableSubtitles(subtitlesTrackId);
            }
        },
        {
            key: "disableSubtitles",
            value: function disableSubtitles() {
                this.ensurePlayerEngineItemActive(PlayerCommand.DisableSubtitles);
                this.nativeDisableSubtitles();
            }
        },
        {
            key: "clearSubtitles",
            value: function clearSubtitles() {
                this.notifySubtitleCuesChanged([]);
            }
        },
        {
            key: "setVolume",
            value: /**
     *
     * @param volume A number between 0 and 100
     */ function setVolume(volume) {
                this.ensurePlayerEngineItemActive(PlayerCommand.SetVolume);
                if (!this.isLoaded) {
                    this.modifiedBeforeLoad.volume = volume;
                }
                this.nativeSetVolume(volume);
                // Consider deleting the next line on the future
                // since the native player should be responsible to hook this behaviour
                this.notifyVolumeChanged(volume);
            }
        },
        {
            key: "setMute",
            value: function setMute(isMuted) {
                this.ensurePlayerEngineItemActive(PlayerCommand.SetMute);
                if (!this.isLoaded) {
                    this.modifiedBeforeLoad.isMuted = isMuted;
                }
                if (isMuted) {
                    this.nativeMute();
                } else {
                    this.nativeUnmute();
                }
            }
        },
        {
            key: "setPlayerBitrateLimits",
            value: function setPlayerBitrateLimits(config) {
                var newBitRateLevel = _object_spread({}, this.bitRateLevel);
                newBitRateLevel.config = _object_spread({}, newBitRateLevel.config, config);
                this.nativeSetPlayerBitrateLimits(config);
                this.bitRateLevel = newBitRateLevel;
            }
        },
        {
            key: "resetPlayerBitrateLimits",
            value: function resetPlayerBitrateLimits() {
                this.nativeResetPlayerBitrateLimits();
            }
        },
        {
            key: "setThumbnailVariant",
            value: function setThumbnailVariant(variantId) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        if (!_this.thumbnailManager) {
                            _this.logger.warn('Cannot set thumbnail variant: No thumbnail manager available');
                            return [
                                2,
                                false
                            ];
                        }
                        return [
                            2,
                            _this.thumbnailManager.setThumbnailVariant(variantId)
                        ];
                    });
                })();
            }
        },
        {
            key: "getThumbnailForTime",
            value: function getThumbnailForTime(timeIncludingAds, contentTime, velocity) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        if (!_this.thumbnailManager) {
                            _this.logger.warn('Cannot get thumbnail for time: No thumbnail manager available');
                            return [
                                2,
                                null
                            ];
                        }
                        return [
                            2,
                            _this.thumbnailManager.getThumbnailForTime(timeIncludingAds, contentTime, velocity)
                        ];
                    });
                })();
            }
        },
        {
            key: "raiseErrorAndStop",
            value: // DISCUSS: This is only used (as far as we can tell)
            //          on one player for parsing audio tracks,
            //          maybe for the id3 tags?
            //          Do we want to keep this here, like it is?
            /* public getManifest(): Promise<Manifest> {
      return this.manifestLoader.getManifest();
  } */ function raiseErrorAndStop(error) {
                this.notifyError(error);
                this.stop(StopReason.Error);
            }
        },
        {
            key: "waitForState",
            value: function waitForState(state) {
                return this.waitForStateFromObservable(state, this.onStateChanged.bind(this));
            }
        },
        {
            key: "isActive",
            value: function isActive() {
                return this.state !== PlayerState.Stopped && !this.hasBeenStopped;
            }
        },
        {
            key: "getCurrentPosition",
            value: function getCurrentPosition() {
                return this.currentPosition;
            }
        },
        {
            key: "getLiveWindow",
            value: function getLiveWindow() {
                var _this = this;
                return _async_to_generator(function() {
                    var _CoreVideoInternal_playerCapabilities, nativeLiveWindow, _nativeLiveWindow_anchor;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.ensurePlayerEngineItemActive(PlayerCommand.GetLiveWindow);
                                if (!checkIsManifestLinearType(_this.playoutData.type)) {
                                    throw new Error('This method is only available for live streams');
                                }
                                return [
                                    4,
                                    _this.nativeLiveWindow()
                                ];
                            case 1:
                                nativeLiveWindow = _state.sent();
                                if (!((_CoreVideoInternal_playerCapabilities = CoreVideoInternal.playerCapabilities) === null || _CoreVideoInternal_playerCapabilities === void 0 ? void 0 : _CoreVideoInternal_playerCapabilities.canSeekByDate) && nativeLiveWindow) {
                                    nativeLiveWindow = _this.addDefaultLiveStartDate(nativeLiveWindow);
                                }
                                if ((nativeLiveWindow === null || nativeLiveWindow === void 0 ? void 0 : nativeLiveWindow.startDate) && !_this.liveWindowAnchor) {
                                    ;
                                    _this.liveWindowAnchor = (_nativeLiveWindow_anchor = nativeLiveWindow.anchor) !== null && _nativeLiveWindow_anchor !== void 0 ? _nativeLiveWindow_anchor : {
                                        relativeTime: nativeLiveWindow === null || nativeLiveWindow === void 0 ? void 0 : nativeLiveWindow.start,
                                        date: nativeLiveWindow === null || nativeLiveWindow === void 0 ? void 0 : nativeLiveWindow.startDate
                                    };
                                }
                                if (nativeLiveWindow && !(nativeLiveWindow === null || nativeLiveWindow === void 0 ? void 0 : nativeLiveWindow.anchor)) {
                                    nativeLiveWindow.anchor = _this.liveWindowAnchor;
                                }
                                return [
                                    2,
                                    nativeLiveWindow
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTelemetryData",
            value: function getTelemetryData() {
                var _this = this;
                return _async_to_generator(function() {
                    var nativeTelemetryData, _nativeTelemetryData_currentPositionSeconds, liveWindow;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.isActive()) {
                                    _this.logger.warn('PEI is not active cannot gather Telemetry Data');
                                    return [
                                        2,
                                        {}
                                    ];
                                }
                                nativeTelemetryData = _this.getNativeTelemetryData();
                                nativeTelemetryData.currentPositionSeconds = (_nativeTelemetryData_currentPositionSeconds = nativeTelemetryData.currentPositionSeconds) !== null && _nativeTelemetryData_currentPositionSeconds !== void 0 ? _nativeTelemetryData_currentPositionSeconds : _this.getCurrentPosition();
                                if (!(!nativeTelemetryData.liveLatencySeconds && checkIsManifestLinearType(_this.playoutData.type))) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.getLiveWindow()
                                ];
                            case 1:
                                liveWindow = _state.sent();
                                if (liveWindow) {
                                    nativeTelemetryData.liveLatencySeconds = liveWindow.end - nativeTelemetryData.currentPositionSeconds;
                                }
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    nativeTelemetryData
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getBufferedInfo",
            value: /***
     *
     * Retrieve the time ranges currently held in the buffer. Returns empty array if the buffer is empty or null if
     * querying buffered ranges is not supported.
     *
     ***/ function getBufferedInfo() {
                return null;
            }
        },
        {
            key: "getNativeTelemetryData",
            value: function getNativeTelemetryData() {
                return {};
            }
        },
        {
            key: "interpolatePosition",
            value: /***
     *
     * Interpolated position handling logic
     *
     ***/ function interpolatePosition(callback, positionAdapter, positionFilter) {
                var _this = this;
                var _this_interpolatedPosition;
                (_this_interpolatedPosition = this.interpolatedPosition) === null || _this_interpolatedPosition === void 0 ? void 0 : _this_interpolatedPosition.onPositionUpdate(callback);
                return function(event, forceUpdate) {
                    var position = positionAdapter(event);
                    if (!positionFilter || positionFilter(position)) {
                        var _this_interpolatedPosition;
                        (_this_interpolatedPosition = _this.interpolatedPosition) === null || _this_interpolatedPosition === void 0 ? void 0 : _this_interpolatedPosition.nativePositionUpdated(position, forceUpdate);
                    }
                };
            }
        },
        {
            key: "notifyHttpRequest",
            value: /***
     *
     * NATIVE PLAYER ABSTRACTIONS
     * To be implemented by native players
     *
     ***/ // Should return the seeked to position or a negative value if no seek was done
            /* DISCUSS: The Player had this behaviour
                this should (maybe?) be handled on an adapter?
                Since the nativePlayers implement nativePause and nativePlay
                shouldn't they implement nativeSeek instead of initiateSeek?!
    /*
    /*
    public nativeSeek(position: number): Promise<void> {
        this.initiateSeek(position);
        return this.waitForState(PlayerState.Playing);
    }
    */ /***
     *
     * OBSERVABLES
     *
     * ***/ function notifyHttpRequest(httpRequest) {
                var _this_httpRequestObservable;
                (_this_httpRequestObservable = this.httpRequestObservable) === null || _this_httpRequestObservable === void 0 ? void 0 : _this_httpRequestObservable.notifyObservers(httpRequest);
            }
        },
        {
            key: "notifyHttpResponse",
            value: function notifyHttpResponse(httpResponse) {
                var _this_httpResponseObservable;
                (_this_httpResponseObservable = this.httpResponseObservable) === null || _this_httpResponseObservable === void 0 ? void 0 : _this_httpResponseObservable.notifyObservers(httpResponse);
            }
        },
        {
            key: "notifyStateChanged",
            value: function notifyStateChanged(state) {
                var _this_internalPlayerStateObservable, _this_stallDetector, _this_stallDetector_isAdDataSet, _this_stallDetector1, _this_gatedPlayerStateObservable, _CoreVideoInternal_playerCapabilities;
                var isValidState = state in PlayerState;
                if (!isValidState) {
                    throw new Error('unknown state: ' + state);
                }
                (_this_internalPlayerStateObservable = this.internalPlayerStateObservable) === null || _this_internalPlayerStateObservable === void 0 ? void 0 : _this_internalPlayerStateObservable.notifyObservers(state);
                (_this_stallDetector = this.stallDetector) === null || _this_stallDetector === void 0 ? void 0 : _this_stallDetector.handleStateChanged(state);
                if (this.adPolicyManager && ((_this_stallDetector1 = this.stallDetector) === null || _this_stallDetector1 === void 0 ? void 0 : (_this_stallDetector_isAdDataSet = _this_stallDetector1.isAdDataSet) === null || _this_stallDetector_isAdDataSet === void 0 ? void 0 : _this_stallDetector_isAdDataSet.call(_this_stallDetector1)) === false) {
                    var _this_stallDetector_setAdBreaksData, _this_stallDetector2;
                    (_this_stallDetector_setAdBreaksData = (_this_stallDetector2 = this.stallDetector).setAdBreaksData) === null || _this_stallDetector_setAdBreaksData === void 0 ? void 0 : _this_stallDetector_setAdBreaksData.call(_this_stallDetector2, this.adPolicyManager.getAdBreaks());
                }
                if (this.shouldIgnoreStateAndPositionChanges && state !== PlayerState.Stopped) {
                    return;
                }
                var isPausedOrPlaying = [
                    PlayerState.Playing,
                    PlayerState.Paused
                ].includes(state);
                if (!checkIsManifestLinearType(this.playoutData.type) && !this.firstPositionUpdateSent && isPausedOrPlaying) {
                    this.notifyPositionChanged(this.currentPosition);
                }
                this.additionalStateLogging(state);
                this.state = state;
                (_this_gatedPlayerStateObservable = this.gatedPlayerStateObservable) === null || _this_gatedPlayerStateObservable === void 0 ? void 0 : _this_gatedPlayerStateObservable.notifyObservers(state, this.currentPosition);
                if ((_CoreVideoInternal_playerCapabilities = CoreVideoInternal.playerCapabilities) === null || _CoreVideoInternal_playerCapabilities === void 0 ? void 0 : _CoreVideoInternal_playerCapabilities.hasSeekingStateSupport) {
                    if (state === PlayerState.Seeking) {
                        this.isOfficiallySeeking = true;
                    } else if (this.isOfficiallySeeking && isPausedOrPlaying) {
                        this.notifySeekEnded();
                    }
                }
            }
        },
        {
            key: "catchNonEngineItemSeek",
            value: // Function to handle if seeking was triggered outside of PEI (e.g. via touchbar)
            //
            // 🚨 WARNING 🚨: Shaka uses these for gap jumping, so the decision
            // has been made to avoid manipulating these events via the policy manager
            // despite the fact that this allows the skipping of ads
            function catchNonEngineItemSeek(seekData) {
                var isAlreadyProcessed = this.seekDataManager.checkSeekPositionEquality(seekData.to, this.seekDataManager.to) || this.seekDataManager.checkSeekPositionEquality(seekData.from, seekData.to);
                if (this.state === PlayerState.Loading || isAlreadyProcessed) {
                    return false;
                }
                this.seekDataManager.update(seekData, true);
                this.notifySeekStarted(this.seekDataManager.to);
                return true;
            }
        },
        {
            key: "notifySeekStarted",
            value: function notifySeekStarted(positionSeconds) {
                var _this_timedActionsScheduler, _this_adPolicyManager, _this_seekStartedObservable, _this_seekStartedObservable1, _this_configuration;
                (_this_timedActionsScheduler = this.timedActionsScheduler) === null || _this_timedActionsScheduler === void 0 ? void 0 : _this_timedActionsScheduler.notifySeekStarted(positionSeconds);
                if (positionSeconds >= 0) {
                    var _this_interpolatedPosition;
                    (_this_interpolatedPosition = this.interpolatedPosition) === null || _this_interpolatedPosition === void 0 ? void 0 : _this_interpolatedPosition.handleSeek(positionSeconds);
                }
                (_this_adPolicyManager = this.adPolicyManager) === null || _this_adPolicyManager === void 0 ? void 0 : _this_adPolicyManager.seekStarted();
                (_this_seekStartedObservable = this.seekStartedObservable) === null || _this_seekStartedObservable === void 0 ? void 0 : _this_seekStartedObservable.reset();
                (_this_seekStartedObservable1 = this.seekStartedObservable) === null || _this_seekStartedObservable1 === void 0 ? void 0 : _this_seekStartedObservable1.notifyObservers(positionSeconds);
                if (!((_this_configuration = this.configuration) === null || _this_configuration === void 0 ? void 0 : _this_configuration.disableSeekingPositionUpdate)) {
                    this.notifyPositionChanged(positionSeconds, true);
                }
            }
        },
        {
            key: "notifySeekEnded",
            value: function notifySeekEnded() {
                var _this_adPolicyManager, _this_seekEndedObservable;
                this.isOfficiallySeeking = false;
                this.seekDataManager.clear();
                (_this_adPolicyManager = this.adPolicyManager) === null || _this_adPolicyManager === void 0 ? void 0 : _this_adPolicyManager.seekEnded();
                (_this_seekEndedObservable = this.seekEndedObservable) === null || _this_seekEndedObservable === void 0 ? void 0 : _this_seekEndedObservable.notifyObservers();
            }
        },
        {
            key: "notifyPlayStart",
            value: function notifyPlayStart() {
                var _this_playStartObservable;
                (_this_playStartObservable = this.playStartObservable) === null || _this_playStartObservable === void 0 ? void 0 : _this_playStartObservable.notifyObservers();
            }
        },
        {
            key: "notifyBitrateChanged",
            value: function notifyBitrateChanged(bitrateLevel) {
                var _this_bitrateObservable;
                var newBitRateLevel = _object_spread({}, this.bitRateLevel, bitrateLevel);
                this.setBitrate(newBitRateLevel);
                (_this_bitrateObservable = this.bitrateObservable) === null || _this_bitrateObservable === void 0 ? void 0 : _this_bitrateObservable.notifyObservers(newBitRateLevel);
            }
        },
        {
            key: "notifyEncodedFrameRateChanged",
            value: function notifyEncodedFrameRateChanged(frameRate) {
                var _this_encodedFrameRateObservable;
                (_this_encodedFrameRateObservable = this.encodedFrameRateObservable) === null || _this_encodedFrameRateObservable === void 0 ? void 0 : _this_encodedFrameRateObservable.notifyObservers(frameRate);
            }
        },
        {
            key: "notifyRenderedFrameRateChanged",
            value: function notifyRenderedFrameRateChanged(frameRate) {
                var _this_renderedFrameRateObservable;
                (_this_renderedFrameRateObservable = this.renderedFrameRateObservable) === null || _this_renderedFrameRateObservable === void 0 ? void 0 : _this_renderedFrameRateObservable.notifyObservers(frameRate);
            }
        },
        {
            key: "notifyVideoTrackChanged",
            value: function notifyVideoTrackChanged(videoTrack) {
                var _this_videoTrackChangedObservable;
                (_this_videoTrackChangedObservable = this.videoTrackChangedObservable) === null || _this_videoTrackChangedObservable === void 0 ? void 0 : _this_videoTrackChangedObservable.notifyObservers(videoTrack);
            }
        },
        {
            key: "notifyPositionChanged",
            value: function notifyPositionChanged(currentPosition, shouldBypassSeekCheck) {
                var _this_timedActionsScheduler, _this_currentPositionObservable, _this_adPolicyManager, _this_stallDetector, _this_subtitlesManager;
                // It's possible for a position update to occur during seeking which can cause issues
                // with Timed Metadata and AdBreak Events if the seek is intended to be blocked
                if (!shouldBypassSeekCheck && this.state === PlayerState.Seeking) {
                    return;
                }
                this.firstPositionUpdateSent = true;
                this.currentPosition = currentPosition;
                (_this_timedActionsScheduler = this.timedActionsScheduler) === null || _this_timedActionsScheduler === void 0 ? void 0 : _this_timedActionsScheduler.notifyPositionChanged(currentPosition);
                (_this_currentPositionObservable = this.currentPositionObservable) === null || _this_currentPositionObservable === void 0 ? void 0 : _this_currentPositionObservable.notifyObservers(currentPosition);
                (_this_adPolicyManager = this.adPolicyManager) === null || _this_adPolicyManager === void 0 ? void 0 : _this_adPolicyManager.notifyPositionChanged(currentPosition);
                this.bufferAnalyser.executeBufferGapDetection(this.getBufferedInfo());
                (_this_stallDetector = this.stallDetector) === null || _this_stallDetector === void 0 ? void 0 : _this_stallDetector.handlePositionChanged(currentPosition);
                (_this_subtitlesManager = this.subtitlesManager) === null || _this_subtitlesManager === void 0 ? void 0 : _this_subtitlesManager.handlePositionUpdate(currentPosition);
            }
        },
        {
            key: "notifyDurationChanged",
            value: function notifyDurationChanged(duration) {
                var _this_durationObservable;
                (_this_durationObservable = this.durationObservable) === null || _this_durationObservable === void 0 ? void 0 : _this_durationObservable.notifyObservers(duration);
            }
        },
        {
            key: "notifyAvailableAudioTracksChanged",
            value: function notifyAvailableAudioTracksChanged(tracks) {
                var _this_availableAudioTracksObservable;
                var modifiedTracks = this.addPrimaryLanguageFlag(tracks);
                (_this_availableAudioTracksObservable = this.availableAudioTracksObservable) === null || _this_availableAudioTracksObservable === void 0 ? void 0 : _this_availableAudioTracksObservable.notifyObservers(modifiedTracks);
            }
        },
        {
            key: "notifyAvailableSubtitlesTracksChanged",
            value: function notifyAvailableSubtitlesTracksChanged(tracks) {
                var _this_availableSubtitlesTracksObservable;
                (_this_availableSubtitlesTracksObservable = this.availableSubtitlesTracksObservable) === null || _this_availableSubtitlesTracksObservable === void 0 ? void 0 : _this_availableSubtitlesTracksObservable.notifyObservers(tracks);
            }
        },
        {
            key: "notifyAvailableThumbnailVariantsChanged",
            value: function notifyAvailableThumbnailVariantsChanged(tracks) {
                var _this_availableThumbnailVariantsObservable;
                (_this_availableThumbnailVariantsObservable = this.availableThumbnailVariantsObservable) === null || _this_availableThumbnailVariantsObservable === void 0 ? void 0 : _this_availableThumbnailVariantsObservable.notifyObservers(tracks);
            }
        },
        {
            key: "notifyWarning",
            value: function notifyWarning(error) {
                var _this_warningObservable;
                (_this_warningObservable = this.warningObservable) === null || _this_warningObservable === void 0 ? void 0 : _this_warningObservable.notifyObservers(error);
            }
        },
        {
            key: "notifyError",
            value: function notifyError(error) {
                // DISCUSS: What should we do to this actual behaviour when
                //          integrating core client SDK with "old" (common player implementations)
                // const errorToReport = this.addonManager.nativePlayerDidError(error);
                if (error.severity === ErrorSeverity.Fatal) {
                    var _this_errorObservable;
                    var stats = this.captureStats();
                    this.logger.breadcrumb("Fatal Error - Player stats: ".concat(JsonUtils.stringify(stats)));
                    (_this_errorObservable = this.errorObservable) === null || _this_errorObservable === void 0 ? void 0 : _this_errorObservable.notifyObservers(error);
                } else {
                    this.notifyWarning(error);
                }
            }
        },
        {
            key: "notifyStreamMetadataReceived",
            value: function notifyStreamMetadataReceived(metadata) {
                var _this_streamMetadataObservable;
                (_this_streamMetadataObservable = this.streamMetadataObservable) === null || _this_streamMetadataObservable === void 0 ? void 0 : _this_streamMetadataObservable.notifyObservers(metadata);
            }
        },
        {
            key: "notifyTimedMetadataReceived",
            value: function notifyTimedMetadataReceived(metadata) {
                var _this_bulkTimedMetadataGatherer, _this_timedMetadataObservable;
                (_this_bulkTimedMetadataGatherer = this.bulkTimedMetadataGatherer) === null || _this_bulkTimedMetadataGatherer === void 0 ? void 0 : _this_bulkTimedMetadataGatherer.push(metadata);
                (_this_timedMetadataObservable = this.timedMetadataObservable) === null || _this_timedMetadataObservable === void 0 ? void 0 : _this_timedMetadataObservable.notifyObservers(metadata);
            }
        },
        {
            key: "notifyBulkTimedMetadataReceived",
            value: function notifyBulkTimedMetadataReceived(metadatas) {
                var _this_bulkTimedMetadataObservable;
                (_this_bulkTimedMetadataObservable = this.bulkTimedMetadataObservable) === null || _this_bulkTimedMetadataObservable === void 0 ? void 0 : _this_bulkTimedMetadataObservable.notifyObservers(metadatas);
            }
        },
        {
            key: "notifyAudioTrackChanged",
            value: function notifyAudioTrackChanged(trackId) {
                var _this_currentAudioTrackObservable;
                (_this_currentAudioTrackObservable = this.currentAudioTrackObservable) === null || _this_currentAudioTrackObservable === void 0 ? void 0 : _this_currentAudioTrackObservable.notifyObservers(trackId);
            }
        },
        {
            key: "notifySubtitlesTrackChanged",
            value: function notifySubtitlesTrackChanged(track) {
                var _this_currentSubtitlesTrackObservable;
                (_this_currentSubtitlesTrackObservable = this.currentSubtitlesTrackObservable) === null || _this_currentSubtitlesTrackObservable === void 0 ? void 0 : _this_currentSubtitlesTrackObservable.notifyObservers(track);
            }
        },
        {
            key: "notifySubtitleCuesReset",
            value: function notifySubtitleCuesReset() {}
        },
        {
            key: "notifySubtitleCuesChanged",
            value: function notifySubtitleCuesChanged(subtitleCues) {
                var _this_subtitleCuesObservable;
                (_this_subtitleCuesObservable = this.subtitleCuesObservable) === null || _this_subtitleCuesObservable === void 0 ? void 0 : _this_subtitleCuesObservable.notifyObservers(subtitleCues);
            }
        },
        {
            key: "notifyVolumeChanged",
            value: function notifyVolumeChanged(volume) {
                var _this_volumeObservable;
                (_this_volumeObservable = this.volumeObservable) === null || _this_volumeObservable === void 0 ? void 0 : _this_volumeObservable.notifyObservers(volume);
            }
        },
        {
            key: "notifyMuteChanged",
            value: function notifyMuteChanged(isMuted) {
                var _this_muteObservable;
                this.isCurrentlyMuted = isMuted;
                (_this_muteObservable = this.muteObservable) === null || _this_muteObservable === void 0 ? void 0 : _this_muteObservable.notifyObservers(isMuted);
            }
        },
        {
            key: "notifyCdnSwitch",
            value: function notifyCdnSwitch(cdnSwitchEvent) {
                var _this_cdnSwitchObservable;
                (_this_cdnSwitchObservable = this.cdnSwitchObservable) === null || _this_cdnSwitchObservable === void 0 ? void 0 : _this_cdnSwitchObservable.notifyObservers(cdnSwitchEvent);
            }
        },
        {
            key: "notifyAdBreakDataReceived",
            value: function notifyAdBreakDataReceived(adBreaks) {
                var _this_adPolicyManager, _this_stallDetector, _this_adBreakDataReceivedObservable;
                (_this_adPolicyManager = this.adPolicyManager) === null || _this_adPolicyManager === void 0 ? void 0 : _this_adPolicyManager.setAdBreaksData(adBreaks);
                if ((_this_stallDetector = this.stallDetector) === null || _this_stallDetector === void 0 ? void 0 : _this_stallDetector.setAdBreaksData) {
                    var _this_stallDetector1;
                    (_this_stallDetector1 = this.stallDetector) === null || _this_stallDetector1 === void 0 ? void 0 : _this_stallDetector1.setAdBreaksData(adBreaks);
                }
                (_this_adBreakDataReceivedObservable = this.adBreakDataReceivedObservable) === null || _this_adBreakDataReceivedObservable === void 0 ? void 0 : _this_adBreakDataReceivedObservable.notifyObservers(adBreaks);
                this.logger.verbose("AdBreak data received: ".concat(JsonUtils.stringify(adBreaks)));
            }
        },
        {
            key: "notifyAdPositionChanged",
            value: function notifyAdPositionChanged(adPosition) {
                var _this_adPositionObservable;
                (_this_adPositionObservable = this.adPositionObservable) === null || _this_adPositionObservable === void 0 ? void 0 : _this_adPositionObservable.notifyObservers(adPosition);
                this.bufferAnalyser.executeBufferGapDetection(this.getBufferedInfo());
            }
        },
        {
            key: "notifyAdError",
            value: function notifyAdError(error) {
                var _this_adErrorObservable;
                (_this_adErrorObservable = this.adErrorObservable) === null || _this_adErrorObservable === void 0 ? void 0 : _this_adErrorObservable.notifyObservers(error);
            }
        },
        {
            key: "notifyManifestReceived",
            value: function notifyManifestReceived(playerManifestReceivedEvent) {
                var _this_manifestReceivedObservable;
                (_this_manifestReceivedObservable = this.manifestReceivedObservable) === null || _this_manifestReceivedObservable === void 0 ? void 0 : _this_manifestReceivedObservable.notifyObservers(playerManifestReceivedEvent);
            }
        },
        {
            key: "notifyLiveWindowChanged",
            value: function notifyLiveWindowChanged(liveWindow) {
                var _CoreVideoInternal_playerCapabilities, _this_liveWindowChangedObservable;
                if (!((_CoreVideoInternal_playerCapabilities = CoreVideoInternal.playerCapabilities) === null || _CoreVideoInternal_playerCapabilities === void 0 ? void 0 : _CoreVideoInternal_playerCapabilities.canSeekByDate) && liveWindow) {
                    liveWindow = this.addDefaultLiveStartDate(liveWindow);
                }
                (_this_liveWindowChangedObservable = this.liveWindowChangedObservable) === null || _this_liveWindowChangedObservable === void 0 ? void 0 : _this_liveWindowChangedObservable.notifyObservers(liveWindow);
            }
        },
        {
            key: "notifyVideoElementCreated",
            value: function notifyVideoElementCreated(videoElement) {
                var _this_videoElementCreatedObservable;
                (_this_videoElementCreatedObservable = this.videoElementCreatedObservable) === null || _this_videoElementCreatedObservable === void 0 ? void 0 : _this_videoElementCreatedObservable.notifyObservers(videoElement);
            }
        },
        {
            key: "notifyFullscreenChanged",
            value: function notifyFullscreenChanged(isFullscreen) {
                var _this_fullscreenChangedObservable;
                (_this_fullscreenChangedObservable = this.fullscreenChangedObservable) === null || _this_fullscreenChangedObservable === void 0 ? void 0 : _this_fullscreenChangedObservable.notifyObservers(isFullscreen);
            }
        },
        {
            key: "notifyClicked",
            value: function notifyClicked() {
                var _this_clickedObservable;
                (_this_clickedObservable = this.clickedObservable) === null || _this_clickedObservable === void 0 ? void 0 : _this_clickedObservable.notifyObservers();
            }
        },
        {
            key: "notifyAutoPlayPolicyPreventedPlayback",
            value: function notifyAutoPlayPolicyPreventedPlayback() {
                var _this_autoPlayPolicyPreventedPlaybackObservable;
                (_this_autoPlayPolicyPreventedPlaybackObservable = this.autoPlayPolicyPreventedPlaybackObservable) === null || _this_autoPlayPolicyPreventedPlaybackObservable === void 0 ? void 0 : _this_autoPlayPolicyPreventedPlaybackObservable.notifyObservers();
            }
        },
        {
            key: "waitForNonGatedState",
            value: function waitForNonGatedState(state) {
                return this.waitForStateFromObservable(state, this.onNonGatedStateChanged.bind(this));
            }
        },
        {
            key: "addDefaultLiveStartDate",
            value: function addDefaultLiveStartDate(liveWindow) {
                if (!liveWindow || liveWindow.startDate) {
                    return liveWindow;
                }
                var windowLengthSec = liveWindow.end - liveWindow.start;
                var startDate = new Date(Date.now() - windowLengthSec * 1000);
                return _object_spread_props(_object_spread({}, liveWindow), {
                    startDate: startDate
                });
            }
        },
        {
            key: "hasCalledLoad",
            value: function hasCalledLoad() {
                return this.isLoading || this.isLoaded;
            }
        },
        {
            key: "getInterpolationStrategy",
            value: function getInterpolationStrategy() {
                var _this_debugConfig, _this_configuration, _this_playoutData_adInsertionConfig;
                if (((_this_debugConfig = this.debugConfig) === null || _this_debugConfig === void 0 ? void 0 : _this_debugConfig.interpolationStrategy) !== undefined) {
                    var _this_debugConfig1;
                    return (_this_debugConfig1 = this.debugConfig) === null || _this_debugConfig1 === void 0 ? void 0 : _this_debugConfig1.interpolationStrategy;
                } else if (((_this_configuration = this.configuration) === null || _this_configuration === void 0 ? void 0 : _this_configuration.interpolationStrategy) !== undefined) {
                    var _this_configuration1;
                    return (_this_configuration1 = this.configuration) === null || _this_configuration1 === void 0 ? void 0 : _this_configuration1.interpolationStrategy;
                } else if (((_this_playoutData_adInsertionConfig = this.playoutData.adInsertionConfig) === null || _this_playoutData_adInsertionConfig === void 0 ? void 0 : _this_playoutData_adInsertionConfig.adInsertionStrategy) === AdInsertionStrategy.SSAI) {
                    return InterpolationStrategies.FullInterpolation;
                } else {
                    return InterpolationStrategies.JustThrottle;
                }
            }
        },
        {
            key: "buildInterpolation",
            value: function buildInterpolation() {
                var interpStart = this.getInterpolationStrategy();
                this.logger.info("Using interpolation strategy: ".concat(interpStart));
                return new InterpolatedPosition({
                    strategy: interpStart,
                    isLive: checkIsManifestLinearType(this.playoutData.type),
                    positionEngine: this,
                    positionUpdateFrequencySeconds: this.playerEngineOptions.progressReportingInterval,
                    isLowEndDevice: CoreVideoInternal.capabilities.hasLowerEndSpecs(),
                    startPosition: this.playoutData.position
                });
            }
        },
        {
            key: "ensurePlayerEngineItemActive",
            value: function ensurePlayerEngineItemActive(command) {
                if (!this.isActive()) {
                    throw new Error("Tried to access PEI via ".concat(command, " command after PEI has stopped"));
                }
            }
        },
        {
            key: "registerStateObserver",
            value: // DISCUSS: AS well as "getManifest" this might not be needed
            /* protected setManifestLoader(loader: ManifestLoader) {
        this.manifestLoader = loader;
    } */ function registerStateObserver(forState, callback, callbackOwner) {
                var _this_gatedPlayerStateObservable;
                var stateCallback = function(state) {
                    if (state === forState) {
                        callback();
                    }
                };
                (_this_gatedPlayerStateObservable = this.gatedPlayerStateObservable) === null || _this_gatedPlayerStateObservable === void 0 ? void 0 : _this_gatedPlayerStateObservable.registerObserver(stateCallback, callbackOwner);
            }
        },
        {
            key: "additionalStateLogging",
            value: // DISCUSS: playerDidEnd method is a mere copy of the behaviour of sessionDidEnd
            //           but since session is not to be handled here, I'll leave it behind so
            //           we can assess latter on if this is to be called by session manager or
            //           if it is not needed by some reason
            /* private playerDidEnd(reason: StopReason) {
        this.bitrateObservable.reset();
        this.currentPositionObservable.reset();
        this.durationObservable.reset();
        this.availableAudioTracksObservable.reset();
        this.availableSubtitlesTracksObservable.reset();
        this.currentAudioTrackObservable.reset();
        this.currentSubtitlesTrackObservable.reset();
    } */ function additionalStateLogging(state) {
                if (state !== this.state) {
                    var currentStateString = PlayerState[this.state];
                    var nextStateString = PlayerState[state];
                    this.logger.breadcrumb("State changed: ".concat(currentStateString, " -> ").concat(nextStateString));
                }
                if (state === PlayerState.Rebuffering) {
                    var stats = this.captureStats();
                    this.logger.breadcrumb("Rebuffering detected - Player stats: ".concat(JsonUtils.stringify(stats)));
                }
                if (this.state !== PlayerState.Rebuffering && state === PlayerState.Rebuffering) {
                    this.logger.breadcrumb("Rebuffering manifest url: ".concat(this.playoutData.cdns[0].url));
                    this.logger.breadcrumb("Entered rebuffering at stream position: ".concat(this.currentPosition));
                    var bufferedInfo = this.getBufferedInfo();
                    if (bufferedInfo !== null) {
                        var bufferedInfoString = this.bufferAnalyser.createBufferedInfoString(bufferedInfo);
                        this.logger.breadcrumb(bufferedInfoString);
                    }
                }
            }
        },
        {
            key: "triggerSeek",
            value: function triggerSeek(positionSeconds) {
                var overrideSeekAllowedInAds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this_stallDetector_getAdBreakStartPositions, _this_stallDetector;
                var avoidCuePointPosition = this.stallDetector && findCloseToAdBreakStartPosition(positionSeconds, (_this_stallDetector_getAdBreakStartPositions = (_this_stallDetector = this.stallDetector).getAdBreakStartPositions) === null || _this_stallDetector_getAdBreakStartPositions === void 0 ? void 0 : _this_stallDetector_getAdBreakStartPositions.call(_this_stallDetector));
                if (avoidCuePointPosition) {
                    positionSeconds = avoidCuePointPosition;
                }
                // `seekStarted` must be notified before `buffering` so that it is not counted as connection induced
                this.notifySeekStarted(positionSeconds);
                var position = this.nativeSeek(positionSeconds);
                if (overrideSeekAllowedInAds) {
                    // We need to clear seekDataManager here when we perform a seek to the adjusted start position, it will
                    // not be cleared by notifyStateChanged.
                    this.seekDataManager.clear();
                }
                return position;
            }
        },
        {
            key: "setBitrate",
            value: function setBitrate(bitrateLevel) {
                this.logger.info("Bitrate Level changed: ".concat(bitrateLevel.bitrateKbps, " Kbps"));
                this.bitRateLevel = bitrateLevel;
            }
        },
        {
            key: "initialiseLoggerObservables",
            value: function initialiseLoggerObservables() {
                this.internalPlayerStateObservable = createErrorLoggingObservable('InternalPlayerStateChanged', this.logger);
                this.gatedPlayerStateObservable = createErrorLoggingObservable('PlayerStateChanged', this.logger);
                this.playStartObservable = createErrorLoggingObservable('PlayStart', this.logger);
                this.preSeekStartedObservable = createErrorLoggingObservable('PreSeekStarted', this.logger);
                this.seekStartedObservable = createErrorLoggingObservable('SeekStarted', this.logger);
                this.seekEndedObservable = createErrorLoggingObservable('SeekEnded', this.logger);
                this.bitrateObservable = createErrorLoggingObservable('BitrateChanged', this.logger);
                this.encodedFrameRateObservable = createErrorLoggingObservable('EncodedFrameRateChanged', this.logger);
                this.renderedFrameRateObservable = createErrorLoggingObservable('RenderedFrameRateChanged', this.logger);
                this.videoTrackChangedObservable = new CompositeObservable(// @ts-ignore
                this.attemptToCombineVideoTrackEventPayload, createErrorLogger('VideoTrackChanged', this.logger));
                this.currentPositionObservable = createErrorLoggingObservable('PositionChanged', this.logger);
                this.durationObservable = createErrorLoggingObservable('DurationChanged', this.logger);
                this.availableAudioTracksObservable = createErrorLoggingObservable('AvailableAudioTracksChanged', this.logger);
                this.availableSubtitlesTracksObservable = createErrorLoggingObservable('AvailableSubtitlesTracksChanged', this.logger);
                this.availableThumbnailVariantsObservable = createErrorLoggingObservable('AvailableThumbnailVariantsChanged', this.logger);
                this.errorObservable = createErrorLoggingObservable('Error', this.logger);
                this.warningObservable = createErrorLoggingObservable('Warning', this.logger);
                this.streamMetadataObservable = createErrorLoggingObservable('StreamMetadataReceived', this.logger);
                this.timedMetadataObservable = createErrorLoggingObservable('TimedMetadataReceived', this.logger);
                this.bulkTimedMetadataObservable = createErrorLoggingObservable('BulkTimedMetadataReceived', this.logger);
                this.currentAudioTrackObservable = createErrorLoggingObservable('AudioTrackChanged', this.logger);
                this.currentSubtitlesTrackObservable = createErrorLoggingObservable('SubtitlesTrackChanged', this.logger);
                this.subtitleCuesObservable = createErrorLoggingObservable('SubtitleCuesChanged', this.logger);
                this.volumeObservable = createErrorLoggingObservable('VolumeChanged', this.logger);
                this.muteObservable = createErrorLoggingObservable('MuteChanged', this.logger);
                this.cdnSwitchObservable = createErrorLoggingObservable('CdnSwitch', this.logger);
                this.manifestReceivedObservable = createErrorLoggingObservable('ManifestReceived', this.logger);
                this.videoElementCreatedObservable = createErrorLoggingObservable('VideoElementCreated', this.logger);
                this.fullscreenChangedObservable = createErrorLoggingObservable('FullscreenChanged', this.logger);
                this.clickedObservable = createErrorLoggingObservable('Clicked', this.logger);
                this.autoPlayPolicyPreventedPlaybackObservable = createErrorLoggingObservable('AutoPlayPolicyPreventedPlayback', this.logger);
                this.adStartedObservable = createErrorLoggingObservable('AdStarted', this.logger);
                this.adFinishedObservable = createErrorLoggingObservable('AdFinished', this.logger);
                this.adBreakStartedObservable = createErrorLoggingObservable('AdBreakStarted', this.logger);
                this.adBreakFinishedObservable = createErrorLoggingObservable('AdBreakFinished', this.logger);
                this.adBreakDataReceivedObservable = createErrorLoggingObservable('AdBreakDataReceived', this.logger);
                this.adPositionObservable = createErrorLoggingObservable('AdPositionChanged', this.logger);
                this.userStoppedObservable = createErrorLoggingObservable('UserStopped', this.logger);
                this.liveWindowChangedObservable = createErrorLoggingObservable('WindowChanged', this.logger);
                this.manifestParsedObservable = createErrorLoggingObservable('ManifestParsed', this.logger);
                this.manifestUpdatedObservable = createErrorLoggingObservable('ManifestUpdated', this.logger);
                this.httpRequestObservable = createErrorLoggingObservable('HttpRequestObservable', this.logger);
                this.httpResponseObservable = createErrorLoggingObservable('HttpResponseObservable', this.logger);
            }
        },
        {
            key: "onNonGatedStateChanged",
            value: function onNonGatedStateChanged(callback, callbackOwner) {
                var _this_internalPlayerStateObservable;
                (_this_internalPlayerStateObservable = this.internalPlayerStateObservable) === null || _this_internalPlayerStateObservable === void 0 ? void 0 : _this_internalPlayerStateObservable.registerObserver(callback, callbackOwner);
            }
        },
        {
            key: "waitForStateFromObservable",
            value: function waitForStateFromObservable(state, registerStateChangedHandler) {
                var _this = this;
                var expectedStates = Array.isArray(state) ? state : [
                    state
                ];
                if (expectedStates.find(function(s) {
                    return s === _this.state;
                }) !== undefined) {
                    return Promise.resolve();
                }
                var callbackOwner = {};
                return new Promise(function(resolve, reject) {
                    registerStateChangedHandler(function(newState) {
                        if (expectedStates.indexOf(newState) >= 0) {
                            resolve();
                            _this.removeEventListeners(callbackOwner);
                        }
                    }, callbackOwner);
                    _this.onError(function(error) {
                        reject(error);
                        _this.removeEventListeners(callbackOwner);
                    }, callbackOwner);
                });
            }
        },
        {
            key: "attemptToCombineVideoTrackEventPayload",
            value: function attemptToCombineVideoTrackEventPayload(param) {
                var bitrateKbps = param.bitrateKbps, resolution = param.resolution, frameRate = param.frameRate, videoCodec = param.videoCodec;
                var _CoreVideoInternal_playerCapabilities;
                if (!bitrateKbps || !frameRate && ((_CoreVideoInternal_playerCapabilities = CoreVideoInternal.playerCapabilities) === null || _CoreVideoInternal_playerCapabilities === void 0 ? void 0 : _CoreVideoInternal_playerCapabilities.canEmitFramerate)) {
                    return null;
                }
                return {
                    shouldReset: true,
                    state: {
                        bitrateKbps: bitrateKbps,
                        resolution: resolution,
                        frameRate: frameRate,
                        videoCodec: videoCodec
                    }
                };
            }
        }
    ]);
    return BasePlayerEngineItem;
}();
_define_property(BasePlayerEngineItem, "idCount", 0);

//# sourceMappingURL=player-engine-item.js.map